import Constant from '../../../common/constant/Constant';
import TelephoneConstant from '@/common/constant/TelephoneConstant';

import { TmpHiddenSysfieldInCreateTicket, TmpHiddenSysFieldInTicketDetail, systemField } from '@/common/constant/SystemField';
import localStorageUtil from '@/common/utils/localStorageUtil';
import Utils from '@/common/utils/utils';
import { copyFileOfTicketDraftTo, createDataListFileDuplicate, getFormFieldData, handleUploadFilesForTicket } from '@/component/common/layout/addTicket/handler/AddTicketHandler';
import { validateErrorTicket, validateExceedSizeOfFieldTicket } from '@/component/common/ValidateTicket';
import { removePanelInitData } from '@/component/multiPanel/panel/handler/PanelHandler';
import { getPublicRangeName, getSystemFieldNameInDrillDown, isDisplayOptionSearchSynonym, emailTicketOriginName } from '@/component/ticketKnowledge/handler/DrilldownAndDetailSearchHandler';
import {
    getFormById,
    getFormByIdWithoutAuthen,
    getFormListByProject,
    getFieldListInForm,
    getFormFieldWithCondition,
    getTagItemsByParentFieldIds,
    getTagItemsByParentFieldId,
    getSystemFieldOfCorp
} from '@/service/formManagementService';
import { getCorporationById } from '@/service/organizationService';
import {
    getProjectById,
    getAllProjectListInCorporation,
    getActiveB2BCustomerProjectListOfProject
} from '@/service/projectService';
import {
    getTicketById,
    createNewTicketAPI,
    editTicketData,
    saveDraftTicketAPI,
    queryListMasterKnowledgeTicketOfForm
} from '@/service/ticketService';
import { getUserById } from '@/service/userService';
import { getPublicAPI } from '@/service/publicService';
import trI18n from '@/common/utils/trI18n';
import { cloneDeep, isArray } from 'lodash';
import { filterTagFieldRequired, isInputAllFieldRequired, filterFieldRequiredForTelephone } from './CreateTicketCommonHandler';
import { getLiveOrArchivedNameInDrillDown } from './HelpDeskTicketListHandler';
import { getAdditionalPermissionsForSave } from './SettingPermissionHandler';
import { getCallHandlerDisplayName, getCallHandlerDisplayType, DRILLDOWN_DISPLAY_TYPE } from '@/common/utils/DrilldownDisplayUtils';
import { getFormFromFormListById, getListCustomFiledOfForm, getRichTextFieldContent, unregisterField, sortListByOrder } from './TicketHandler';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';
import { createKibanaDataContentOperation } from '@/component/system/logKibanaHandler/LogKibanaHandler';
import { createKibanaLogAPI } from '@/service/logKibanaService';
import { reloadPanelAfterSoftDeleteTicketKnowledge } from '@/component/ticketKnowledge/handler/DetailTicketHandler';
import { isDisplaySplitPDF } from '@/component/formManagement/handler/FormListHandler';
import { updateUserWorkLastForm } from '@/common/utils/ServiceFactoryUtil';
import { getBookmarkById } from '@/service/bookmarkService';
import _ from "lodash"
import { getMcpServerByIdList, getMcpServerListByProject, getLocalMcpListForProject, getMcpCatalogDetailById, getListMcpCatalogDetailByIds } from '@/service/mcpServerService';
import { getMCPServerByIdNoValidate } from '@/component/project/MCPServerSetting/handler/MCPServerLogicHandler';
import { parseLocalMcpScope } from '@/common/utils/mcpUtils';
import { LOCAL_MCP_LABEL_PREFIX, LOCAL_MCP_USER_PREFIX, LOCAL_MCP_PROJECT_PREFIX } from '@/component/mcpCatalog/McpCatalogConstant';
import OpenAiUtil from '@/common/utils/OpenAiUtil';
import { NON_TRANSLATABLE_TAG_SYS_FIELDS } from '@/common/utils/translationUtils';
import { buildSnackbarMessage } from '@/component/common/SnackbarMessage';

export const createKnowledgeTicketHandler = async (
    tabId,
    panelType,
    formData,
    userDetail,
    corporationDetail,
    panelId,
    argsAll,
    fieldListData,
    aiAutoSelectedData,
    sdautoSelectedData
) => {
    // check selectedForm
    if (Utils.isEmptyString(argsAll.selectedForm)) {
        argsAll.setIsErrorSelected(true);
        return;
    }

    let viewPermissions = argsAll.viewPermissions;
    let editPermissions = argsAll.editPermissions;
    let additionalViewPermissions = argsAll.additionalViewPermissions;
    let additionalEditPermissions = argsAll.additionalEditPermissions;
    let chatPermission = argsAll.chatPermission;

    if(Utils.isEmptyArray(viewPermissions) || Utils.isEmptyArray(editPermissions) || Utils.isEmptyString(chatPermission)) {
        return;
    }

    argsAll.setIsLoading(true);

    let status = '';
    const statusField = fieldListData.find((fieldData) => fieldData.type === "WORKFLOW");
    if(!Utils.isEmptyObject(statusField)){
        status = statusField.fieldId;
    }

    // convert field to request body
    let fields = await Utils.getCustomFieldValueInFormData(formData, fieldListData, aiAutoSelectedData, sdautoSelectedData);
  
    // validate exceed max size
    if (validateExceedSizeOfFieldTicket(argsAll.fieldListData, argsAll.setFiledListData, fields, argsAll.setErrorMessageHeader)) {
        argsAll.setIsLoading(false);
        return;
    }

    // validate
    if (validateErrorTicket(argsAll, fields)) {
        argsAll.setIsLoading(false);
        return;
    }

    let ticketType = Constant.TICKET_TYPE.KNOWLEDGE;
    let formListClone = cloneDeep(argsAll.formList);
    let formSelectedId = argsAll.selectedForm;
    let formIndex = Utils.findIndexInArrayById(formSelectedId, formListClone);
    if(formIndex !== -1) {
        let formDetail = formListClone[formIndex];
        if(formDetail.type === Constant.FORM_TYPE.FORM_MASTER) {
            ticketType = Constant.TICKET_TYPE.MASTER_KNOWLEDGE
        }
    }

    let viewPermissionsSave = viewPermissions.map(p => p.value);
    let editPermissionsSave = editPermissions.map(p => p.value);
    let additionalViewPermissionsSave = getAdditionalPermissionsForSave(additionalViewPermissions);
    let additionalEditPermissionsSave = getAdditionalPermissionsForSave(additionalEditPermissions);

    let uploadFileS3Result = {
        fileListSuccess: [],
        suffixOfAttachments: {},
        listFileError: []
    };

    uploadFileS3Result = await handleUploadFilesForTicket(
        formData,
        argsAll.setFileUploading,
    );

    let fileUploadedDeleted = [];
    if(!Utils.isEmptyArray(argsAll.fileUpdatedList)) {
        fileUploadedDeleted = argsAll.fileUpdatedList.filter(file => file.isDelete === true);
        if(!Utils.isEmptyArray(fileUploadedDeleted)) {
            fileUploadedDeleted = fileUploadedDeleted.map(file => {
                let fileClone = {...file};
                delete fileClone.isDelete;
                delete fileClone.createdAt;
                delete fileClone?.thumbnailInfo;
                return fileClone
            })
        }
    }

    let newFileUpdatedList = cloneDeep(argsAll.fileUpdatedList);
    if(!Utils.isEmptyArray(newFileUpdatedList)) {
        newFileUpdatedList = newFileUpdatedList.map(file => {
            let fileClone = {...file};
            delete fileClone?.isPrivate;
            return fileClone
        })
    }

    if (Utils.isEmptyArray(uploadFileS3Result.fileListSuccess) && Utils.isEmptyObject(uploadFileS3Result.suffixOfAttachments)) {
        let {suffixOfAttachments, listFileUploadSuccess} = createDataListFileDuplicate(newFileUpdatedList);
        uploadFileS3Result.suffixOfAttachments = suffixOfAttachments;
        newFileUpdatedList = listFileUploadSuccess;
    }

    let draftTicketInfo = {
        isSendDraft: argsAll?.isDraft && !argsAll?.isDuplicate ? true : false,
        fileUploadedList: copyFileOfTicketDraftTo(newFileUpdatedList),
        oldDraftTicketId: argsAll?.detailTicket?.id && !argsAll?.isDuplicate ? argsAll?.detailTicket?.id : '',
        fileUploadedDeleted: fileUploadedDeleted
    };

    let requestBody = {
        createTicketRequestDto: {
            outline: formData.outline,
            corporationOrigin: corporationDetail.id,
            description: formData.description,
            createUserId: userDetail.id,
            projectOrigin: argsAll.projectInuseDetail?.id,
            projectTarget: argsAll.projectInuseDetail?.id,
            corporationTarget: corporationDetail.id,
            ticketType: ticketType,
            affiliationOrganization: corporationDetail.id,
            affiliationProject: argsAll.projectInuseDetail?.id,
            status: status,
            fields: fields,
            type: argsAll.selectedForm,
            customer: Constant.NA,
            viewPermission: viewPermissionsSave,
            additionalViewPermission: JSON.stringify(additionalViewPermissionsSave),
            editPermission: editPermissionsSave,
            additionalEditPermission: JSON.stringify(additionalEditPermissionsSave),
            chatPermission: chatPermission,
            public: Constant.TICKET_PUBLIC.PUBLIC,
            fileListSuccess: uploadFileS3Result.fileListSuccess,
            suffixOfAttachments: JSON.stringify(uploadFileS3Result?.suffixOfAttachments),
            sessionId: localStorageUtil.getSessionBrowserId(),
            isServicesPDFOfCorpOn: isDisplaySplitPDF(corporationDetail, Constant.FORM_TYPE.FORM_KNOWLEDGE),
            ...draftTicketInfo
        },
    };

    // call API create ticket
    let newTicket = await createNewTicketAPI(argsAll.API, requestBody);

    if (!newTicket?.id) {
        argsAll.setIsLoading(false);
        if (newTicket.errorMessage === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
            argsAll.setIsOpenModalReloadPage(true);
        }
        switch (newTicket.errorMessage) {
            case Constant.MSG_SD_DUPLICATED_SCRIPT_TITLE: {
                const outlineField = fieldListData?.find(
                    field => field.sysField?.toLowerCase() === Constant.SYS_FIELD.OUTLINE
                );

                if (outlineField) {
                    return argsAll.setErorsCreateKnowledgeTicket(outlineField.id, {
                        type: 'isValidDuplicateTitle',
                        message: trI18n('MSG-SD-DUPLICATED-SCRIPT-TITLE')
                    });
                }
                break;
            }
            case Constant.MSG_APP_NAME_DUPLICATED: {
                const appNameField = fieldListData?.find(
                    field => field.sysField?.toLowerCase() === Constant.SYS_FIELD.BUSINESS_APP_NAME
                );
                if (appNameField) {
                   return argsAll.setErorsCreateKnowledgeTicket(appNameField.id, {
                        type: 'isValidDuplicateAppName',
                        message: trI18n('MSG-APP-NAME-DUPLICATED')
                    });
                }
                break;
            }
            case Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR: {
                if (argsAll?.setIsOpenModalReloadPage) {
                    argsAll?.setIsOpenModalReloadPage(true)
                }
                return;
            }
            default:
                break;
        }
    }

    let dataUpdateLastForm = {
        typeLastTicket: Constant.TYPE_LAST_FORM.LAST_FORM_KNOWLEDGE,
        formId: argsAll?.selectedForm,
        projectTargetId: argsAll?.projectInuseDetail?.id,
        corpTargetId: corporationDetail?.id
    }

    await updateUserWorkLastForm(dataUpdateLastForm, argsAll.setUserDetail, argsAll.userDetail);

    let lastUserAction = LogKibanaConstant.CONTENT_OPERATION_ACTION.ADD;
    let usingFormName = Utils.convertJSONDataToObject(argsAll.selectedFormInfo.name)?.jp?.text;
    let dataLog = {
        rootCorporationDetail: argsAll.corporationDetail,
        rootProjectDetail: argsAll.projectInuseDetail,
        corporationDetail: argsAll.corporationDetail,
        projectDetail: argsAll.projectInuseDetail,
        userDetail: argsAll.userDetail,
        ticketDetail: {
            id: newTicket.id,
            outline: newTicket.outline,
            creator: newTicket.creator,
            usingFormName: usingFormName,
            createdAt: newTicket.createdAt,
        },
        metaData: {
            formDetailId: argsAll.selectedForm,
            additionalViewPermissions: argsAll.additionalViewPermissions,
            viewPermissions: viewPermissionsSave,
            ticketType,
        },
        isCreateKnowledge: true,
        isCreateCSV: false,
        ticketCreationScreen: LogKibanaConstant.TICKET_CREATION_SCREEN.SOLUTIONDESK
    }

    let logKibanaData = createKibanaDataContentOperation(
        lastUserAction,
        dataLog
    );
    let param = {
        logType: LogKibanaConstant.CONTENT_OPERATION_ACTION.ADD,
        logKibanaData: logKibanaData
    };
    createKibanaLogAPI(argsAll.API, param);
    argsAll.setLastUserAction(null);

    //update usingTicket of formList 
    if(formIndex !== -1) {
        let formDetail = formListClone[formIndex];
        let usingTickets = Utils.convertJSONDataToObject(formDetail.usingTickets);

        if (!Utils.isEmptyObject(usingTickets)) {
            if (usingTickets[newTicket.affiliationProject]) {
                usingTickets[newTicket.affiliationProject].push(newTicket.id);
            } else {
                usingTickets[newTicket.affiliationProject] = [newTicket.id];
            }
        } else {
            usingTickets = {};
            usingTickets[newTicket.affiliationProject] = [newTicket.id];
        }

        formListClone[formIndex].usingTickets = JSON.stringify(usingTickets);
    }
    argsAll.setFormList(formListClone);

    removePanelInitData(panelId, tabId, argsAll.panelInitData, argsAll.setPanelInitData);
    argsAll.updatePanelAfterCreateTicket({
        panelId: panelId,
        tabId: tabId,
        panelType: panelType,
        ticketId: newTicket.id,
        ticketOutline: newTicket.outline,
        API: argsAll.API
    });
    
    argsAll.enqueueSnackbar(
        buildSnackbarMessage(draftTicketInfo.isSendDraft ? 'MSG-CM-PUBLISH-DRAFT-CONTENT-SUCCESSFULLY': 'MSG-CM-CREATE-TICKET-SUCCESS'),
        {variant: 'success', autoHideDuration: 3000}
    );
    return;
};

export const handleOnchangePublicRange = (publicRangeSelected, argsAll) => {
    let newPublicRange = publicRangeSelected;
    if (newPublicRange === argsAll.selectedPublicRange) {
        return;
    }
    // argsAll.setSelectedPublicRange(newPublicRange);
    argsAll.setValueCreateKnowledgeTicket('publicRange', newPublicRange);
};

export const initDataPanelCreateTicketKnowledge = async (currentPanelInitDataRes, argsAll) => {
    let oldArgsAll = currentPanelInitDataRes.argsAll;
    argsAll.isLastActive = true;
    //selected form
    if (oldArgsAll.selectedForm) {
        await onConfirmChangeForm(oldArgsAll.selectedForm, argsAll);
    }

    let additionalViewPermission = getAdditionalPermissionsForSave(oldArgsAll.additionalViewPermissions)
    let additionalEditPermission = getAdditionalPermissionsForSave(oldArgsAll.additionalEditPermissions)

    let dataSettingDefault = {
        viewPermission: oldArgsAll.viewPermissions?.map(p => p.value),
        editPermission: oldArgsAll.editPermissions?.map(p => p.value),
        additionalViewPermission: JSON.stringify(additionalViewPermission),
        additionalEditPermission: JSON.stringify(additionalEditPermission),
        chatPermission: oldArgsAll.chatPermission
    };
    await argsAll.setDataSettingDefaults(dataSettingDefault);

    //open publicRange
    if(oldArgsAll.selectedPublicRange) {
        await handleOnchangePublicRange(oldArgsAll.selectedPublicRange, argsAll)
    }

    // File upload
    let fileUploadListOld = oldArgsAll.fileUploadList;
    if (!Utils.isEmptyArray(fileUploadListOld)) {
        argsAll.setFileUploadList(fileUploadListOld);
        argsAll.setValueCreateKnowledgeTicket(
            'fileUploadList',
            fileUploadListOld
        );
    }

    if (oldArgsAll?.aiAutoSelectedData && argsAll?.setAIAutoSelectedData) {
        await Utils.delay(1000);
        argsAll?.setAIAutoSelectedData(oldArgsAll?.aiAutoSelectedData);
    }

    if (oldArgsAll?.sdautoSelectedData && argsAll?.setSdautoSelectedData) {
        await Utils.delay(1000);
        argsAll?.setSdautoSelectedData(oldArgsAll?.sdautoSelectedData);
    }

    if (oldArgsAll?.aiTelephoneSelectedData && argsAll?.setAITelephoneSelectedData) {
        await Utils.delay(200);
        argsAll?.setAITelephoneSelectedData(oldArgsAll?.aiTelephoneSelectedData);
    }
}

/**
 * displayType for a selected drilldown tag item's itemLabel:
 * - telephone_call_handler: value is either a USER id (never translated) or a KNOWLEDGE id
 *   (AI Operator, system-generated name that must be translated) — checked before the generic
 *   NON_TRANSLATABLE_TAG_SYS_FIELDS rule below, which would otherwise force RAW for both cases
 *   since CALL_HANDLER is listed there for the USER case.
 * - USER/PROJECT identifiers → RAW
 * - sysFields in NON_TRANSLATABLE list (ChatGPT model, phone, etc.) → RAW
 * - master tag field (remaining KNOWLEDGE id) → TAG
 * - regular tag option values → TAG
 */
const getSelectedTagItemDisplayType = (fieldSysField, itemId, itemPrefix) => {
    const callHandlerDisplayType = getCallHandlerDisplayType(fieldSysField, itemId);
    if (callHandlerDisplayType) return callHandlerDisplayType;

    if (
        [Constant.ID_PREFIX.USER, Constant.ID_PREFIX.PROJECT].includes(itemPrefix) ||
        NON_TRANSLATABLE_TAG_SYS_FIELDS.includes(fieldSysField)
    ) {
        return DRILLDOWN_DISPLAY_TYPE.RAW;
    }
    // call handler is already handled above; a remaining KNOWLEDGE id here is a
    // master tag field, which must use trTag() (TAG) like regular tag items
    return DRILLDOWN_DISPLAY_TYPE.TAG;
};

/**
 * get Drilldow nData Selected
 * @param {*} API 
 * @param {*} viewStructure 
 * @param {*} setDrillDownDataSelected 
 * @returns 
 */
export const getDrilldownDataSelected = async (API, viewStructure, setDrillDownDataSelected, authen = true, isKnowledge = true) => {
    viewStructure = Utils.convertJSONDataToObject(viewStructure);
    if (Utils.isEmptyArray(viewStructure.fields) && Utils.isEmptyArray(viewStructure.statusFields) && Utils.isEmptyArray(viewStructure.tagFields) && Utils.isEmptyArray(viewStructure.privateBookmark) && Utils.isEmptyArray(viewStructure.sharedBookmark) && Utils.isEmptyArray(viewStructure.mcpServerSetting)
    ) {
        setDrillDownDataSelected([]);
        return;
    }
    
    let allDrilldownSelectedData = await getDrilldownItemDataSelected(API, viewStructure, authen, isKnowledge);
    setDrillDownDataSelected(allDrilldownSelectedData);
};

/**
 * get Drilldown Item Selected
 * @param {*} argsCommon 
 * @returns 
 */
export const getDrilldownItemDataSelected = async (API, viewStructure, authen = true, isKnowledge = true) => {
    let systemFieldList = viewStructure.fields || [];
    let statusFieldList = viewStructure.statusFields || [];
    let tagFieldList = viewStructure.tagFields || [];
    let privateBookmark = viewStructure.privateBookmark || [];
    let sharedBookmark = viewStructure.sharedBookmark || [];
    let mcpServerSetting = viewStructure.mcpServerSetting || [];
    let ticketCreatedProjectId = ''
    if(isKnowledge){
        ticketCreatedProjectId = viewStructure.ticketCreatedProjectId
    }else{
        ticketCreatedProjectId = localStorageUtil.getSelectedProjectId()
    };

    let listSystemField = []
    if(ticketCreatedProjectId){
        const projectDetail = await getProjectById(API, ticketCreatedProjectId);
        listSystemField = await getSystemFieldOfCorp(projectDetail.affiliationOrganization);
    }
    let dataDrilldownSelected = [];
    if (!Utils.isEmptyArray(systemFieldList)) {
        await Promise.all(
            systemFieldList.map(async (field) => {
                let fieldId = !Utils.isEmptyArray(Object.keys(field)) ? Object.keys(field)[0] : '';
                if (
                    fieldId &&
                    [
                        Constant.DRILLDOWN_TYPE_TEXT.FORM,
                        Constant.DRILLDOWN_TYPE_TEXT.TICKET_TYPE,
                        Constant.DRILLDOWN_TYPE_TEXT.PROJECT_ORIGIN,
                        Constant.DRILLDOWN_TYPE_TEXT.PROJECT_TARGET,
                        Constant.DRILLDOWN_TYPE_TEXT.NOTICE_TARGET_USER,
                        Constant.DRILLDOWN_TYPE_TEXT.CREATOR,
                        Constant.DRILLDOWN_TYPE_TEXT.UPDATOR,
                        Constant.DRILLDOWN_TYPE_TEXT.PROXIED_USER,
                        Constant.DRILLDOWN_TYPE_TEXT.PUBLIC_RANGE,
                        Constant.DRILLDOWN_TYPE_TEXT.LIVE_OR_ARCHIVED,
                        Constant.DRILLDOWN_TYPE_TEXT.PERSON_IN_CHARGE,
                        Constant.DRILLDOWN_TYPE_TEXT.TELEPHONE_EVALUATOR,
                        Constant.DRILLDOWN_TYPE_TEXT.EMAIL_TICKET_ORIGIN
                    ].includes(fieldId)
                ) {
                    let labelName = '';
                    let itemSelected = field[fieldId];
                    let order = 0;
                    if (!itemSelected) {
                        return;
                    }

                    let isDisplay = true;
                    let systemFieldData = {};
                    let hideInProject = {}
                    switch (fieldId) {
                        case Constant.DRILLDOWN_TYPE_TEXT.FORM: {
                            let formData = authen ? await getFormById(API, itemSelected) : await getFormByIdWithoutAuthen(API, itemSelected);
                            if (!Utils.isEmptyObject(formData)) {
                                labelName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, formData.name);
                                order = 1;
                            };
                            if(!Utils.isEmptyArray(listSystemField)){
                                systemFieldData =  listSystemField?.find(sysField => sysField.sysField === Constant.ONLY_DRILLDOWN_SYSTEM_FIELD.SYSTEM_FIELD.SYSTEM_TAGS_FORM);
                                hideInProject = Utils.convertJSONDataToObject(systemFieldData?.hideInProject);
                                if(hideInProject[ticketCreatedProjectId] == 1){
                                    isDisplay = false
                                }
                            }
                            break;
                        }
                        case Constant.DRILLDOWN_TYPE_TEXT.TICKET_TYPE:
                            labelName = itemSelected;
                            order = 7;
                            if(!Utils.isEmptyArray(listSystemField)){
                                systemFieldData =  listSystemField?.find(sysField => sysField.sysField === Constant.ONLY_DRILLDOWN_SYSTEM_FIELD.SYSTEM_FIELD.TICKET_TYPE_CATEGORY);
                                hideInProject = Utils.convertJSONDataToObject(systemFieldData.hideInProject);
                                if(hideInProject[ticketCreatedProjectId] == 1){
                                    isDisplay = false
                                }
                            }
                            break;
                        case Constant.DRILLDOWN_TYPE_TEXT.PROJECT_ORIGIN:
                            labelName = await getProjectNameDrillDownDataSelected(API, itemSelected);
                            switch (fieldId) {
                                case Constant.DRILLDOWN_TYPE_TEXT.PROJECT_ORIGIN:
                                    order = 1.1;
                                    break;
                                case Constant.DRILLDOWN_TYPE_TEXT.PROJECT_TARGET:
                                    order = 1.2;
                                    break;
                                default:
                                    break;
                            }
                            if(!Utils.isEmptyArray(listSystemField)){
                                systemFieldData =  listSystemField?.find(sysField => sysField.sysField === Constant.ONLY_DRILLDOWN_SYSTEM_FIELD.SYSTEM_FIELD.INQUIRY_SOURCE_PROJECT);
                                hideInProject = Utils.convertJSONDataToObject(systemFieldData.hideInProject);
                                if(hideInProject[ticketCreatedProjectId] == 1){
                                    isDisplay = false
                                }
                            };
                            break
                        case Constant.DRILLDOWN_TYPE_TEXT.PROJECT_TARGET:
                            labelName = await getProjectNameDrillDownDataSelected(API, itemSelected);
                            switch (fieldId) {
                                case Constant.DRILLDOWN_TYPE_TEXT.PROJECT_ORIGIN:
                                    order = 1.1;
                                    break;
                                case Constant.DRILLDOWN_TYPE_TEXT.PROJECT_TARGET:
                                    order = 1.2;
                                    break;
                                default:
                                    break;
                            };
                            if(!Utils.isEmptyArray(listSystemField)){
                                systemFieldData =  listSystemField?.find(sysField => sysField.sysField === Constant.ONLY_DRILLDOWN_SYSTEM_FIELD.SYSTEM_FIELD.NOTICE_TARGET_PROJECT);
                                hideInProject = Utils.convertJSONDataToObject(systemFieldData.hideInProject);
                                if(hideInProject[ticketCreatedProjectId] == 1){
                                    isDisplay = false
                                }
                            };
                            break;
                        case Constant.DRILLDOWN_TYPE_TEXT.NOTICE_TARGET_USER:
                        case Constant.DRILLDOWN_TYPE_TEXT.CREATOR:
                        case Constant.DRILLDOWN_TYPE_TEXT.UPDATOR:
                        case Constant.DRILLDOWN_TYPE_TEXT.PROXIED_USER:
                        case Constant.DRILLDOWN_TYPE_TEXT.PERSON_IN_CHARGE:
                        case Constant.DRILLDOWN_TYPE_TEXT.TELEPHONE_EVALUATOR:
                            if (itemSelected === Constant.ANONYMOUS_USER_ID) {
                                labelName = trI18n('USER04LB052');
                            } else {
                                labelName = await getUserNameDrillDownDataSelected(API, itemSelected);
                            }

                            switch (fieldId) {
                                case Constant.DRILLDOWN_TYPE_TEXT.NOTICE_TARGET_USER:
                                    if (!Utils.isEmptyArray(listSystemField)) {
                                        systemFieldData = listSystemField?.find(
                                            sysField =>
                                                sysField.sysField ===
                                                Constant.ONLY_DRILLDOWN_SYSTEM_FIELD.SYSTEM_FIELD
                                                    .NOTICE_TARGET_USER
                                        );
                                        hideInProject = Utils.convertJSONDataToObject(
                                            systemFieldData.hideInProject
                                        );
                                        if (hideInProject[ticketCreatedProjectId] == 1) {
                                            isDisplay = false;
                                        }
                                    }
                                    order = 2.9;
                                    break;
                                case Constant.DRILLDOWN_TYPE_TEXT.UPDATOR:
                                    if (!Utils.isEmptyArray(listSystemField)) {
                                        systemFieldData = listSystemField?.find(
                                            sysField =>
                                                sysField.sysField ===
                                                Constant.ONLY_DRILLDOWN_SYSTEM_FIELD.SYSTEM_FIELD
                                                    .UPDATOR
                                        );
                                        hideInProject = Utils.convertJSONDataToObject(
                                            systemFieldData.hideInProject
                                        );
                                        if (hideInProject[ticketCreatedProjectId] == 1) {
                                            isDisplay = false;
                                        }
                                    }
                                    order = 3;
                                    break;
                                case Constant.DRILLDOWN_TYPE_TEXT.PROXIED_USER:
                                    if (!Utils.isEmptyArray(listSystemField)) {
                                        systemFieldData = listSystemField?.find(
                                            sysField =>
                                                sysField.sysField ===
                                                Constant.SYSTEM_FIELD.PROXIED_USER
                                        );
                                        hideInProject = Utils.convertJSONDataToObject(
                                            systemFieldData.hideInProject
                                        );
                                        if (hideInProject[ticketCreatedProjectId] == 1) {
                                            isDisplay = false;
                                        }
                                    }
                                    order = 4;
                                    break;
                                case Constant.DRILLDOWN_TYPE_TEXT.CREATOR:
                                    if (!Utils.isEmptyArray(listSystemField)) {
                                        systemFieldData = listSystemField?.find(
                                            sysField =>
                                                sysField.sysField ===
                                                Constant.ONLY_DRILLDOWN_SYSTEM_FIELD.SYSTEM_FIELD.CREATOR
                                        );
                                        hideInProject = Utils.convertJSONDataToObject(
                                            systemFieldData.hideInProject
                                        );
                                        if (hideInProject[ticketCreatedProjectId] == 1) {
                                            isDisplay = false;
                                        }
                                    }
                                    order = 2;
                                    break;
                                case Constant.DRILLDOWN_TYPE_TEXT.PERSON_IN_CHARGE:
                                    if (!Utils.isEmptyArray(listSystemField)) {
                                        systemFieldData = listSystemField?.find(
                                            sysField =>
                                                sysField.sysField ===
                                                Constant.SYSTEM_FIELD.PERSON_IN_CHARGE
                                        );
                                        hideInProject = Utils.convertJSONDataToObject(
                                            systemFieldData.hideInProject
                                        );
                                        if (hideInProject[ticketCreatedProjectId] == 1) {
                                            isDisplay = false;
                                        }
                                    }
                                    order = 2;
                                    break;
                                case Constant.DRILLDOWN_TYPE_TEXT.TELEPHONE_EVALUATOR:
                                    if (!Utils.isEmptyArray(listSystemField)) {
                                        systemFieldData = listSystemField?.find(
                                            sysField =>
                                                sysField.sysField ===
                                                TelephoneConstant.TELEPHONE.SYSTEM_FIELD.EVALUATOR
                                        );
                                        hideInProject = Utils.convertJSONDataToObject(
                                            systemFieldData?.hideInProject
                                        );
                                        if (hideInProject[ticketCreatedProjectId] == 1) {
                                            isDisplay = false;
                                        }
                                    }
                                    order = 2;
                                    break;
                                default:
                                    order = 2;
                                    break;
                            };
                            break;
                        case Constant.DRILLDOWN_TYPE_TEXT.PUBLIC_RANGE:
                            labelName = getPublicRangeName(itemSelected);
                            order = 5;
                            break;
                        case Constant.DRILLDOWN_TYPE_TEXT.LIVE_OR_ARCHIVED:
                            labelName = getLiveOrArchivedNameInDrillDown(itemSelected);
                            if (!Utils.isEmptyArray(listSystemField)) {
                                systemFieldData = listSystemField?.find(
                                    sysField =>
                                        sysField.sysField ===
                                        Constant.ONLY_DRILLDOWN_SYSTEM_FIELD.SYSTEM_FIELD
                                            .ACTIVE_ARCHIVED_STATUS
                                );
                                hideInProject = Utils.convertJSONDataToObject(
                                    systemFieldData.hideInProject
                                );
                                if (hideInProject[ticketCreatedProjectId] == 1) {
                                    isDisplay = false;
                                }
                            }
                            order = 5;
                            break;
                        case Constant.DRILLDOWN_TYPE_TEXT.EMAIL_TICKET_ORIGIN:
                            labelName = emailTicketOriginName(itemSelected);
                            if (!Utils.isEmptyArray(listSystemField)) {
                                systemFieldData = listSystemField?.find(
                                    sysField =>
                                        sysField.sysField ===
                                        Constant.ONLY_DRILLDOWN_SYSTEM_FIELD.SYSTEM_FIELD
                                            .EMAIL_ORIGIN
                                );
                                hideInProject = Utils.convertJSONDataToObject(
                                    systemFieldData.hideInProject
                                );
                                if (hideInProject[ticketCreatedProjectId] == 1) {
                                    isDisplay = false;
                                }
                            }
                            order = 6;
                            break;
                        default:
                            break;
                    }
        
                    dataDrilldownSelected.push({
                        id: fieldId,
                        itemId: itemSelected,
                        label: `${labelName}/${getSystemFieldNameInDrillDown(fieldId)}`,
                        fieldLabel: getSystemFieldNameInDrillDown(fieldId),
                        itemLabel: labelName,
                        isSystemField: true,
                        order: order,
                        isDisplay: isDisplay
                    });
                } else if (fieldId && fieldId === Constant.DRILLDOWN_TYPE_TEXT.SUFFIX_OF_ATTACHMENTS) {
                    let systemFieldData = {};
                    let hideInProject = {};
                    let isDisplay = true;
                    let attachmentsSelected = field[fieldId];
                    if (!Utils.isEmptyArray(listSystemField)) {
                         systemFieldData = listSystemField?.find(
                             sysField =>
                                 sysField.sysField ===
                                 Constant.ONLY_DRILLDOWN_SYSTEM_FIELD.SYSTEM_FIELD
                                     .SUFFIX_OF_ATTACHMENTS
                         );
                         hideInProject = Utils.convertJSONDataToObject(
                             systemFieldData.hideInProject
                         );
                         if (hideInProject[ticketCreatedProjectId] == 1) {
                             isDisplay = false;
                         }
                    }
                    dataDrilldownSelected.push({
                        id: fieldId,
                        itemId: attachmentsSelected,
                        label: `${attachmentsSelected}/${getSystemFieldNameInDrillDown(fieldId)}`,
                        fieldLabel: getSystemFieldNameInDrillDown(fieldId),
                        itemLabel: attachmentsSelected,
                        isSystemField: true,
                        isDisplay: isDisplay,
                        order: 6,
                    });
                }
            })
        );
    }

    if (!Utils.isEmptyArray(privateBookmark) || !Utils.isEmptyArray(sharedBookmark)) {
        let privateBookmarkOptionList = privateBookmark?.map(option => {
            let optionClone = {...option}
            optionClone.isPrivate = true;
            return optionClone
        });
        let listSelectedBookmarkOption = [...privateBookmarkOptionList, ...sharedBookmark];
        await Promise.all(
            listSelectedBookmarkOption?.map(async option => {
                let bookmarkID = option.bookmarkId;
                const bookmarkData = await getBookmarkById(bookmarkID);
                let labelName = Utils.isEmptyObject(bookmarkData)
                    ? ''
                    : Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, bookmarkData.name);
                let order = option.isPrivate ? 6.8 : 6.9;
                let optionId =  option.isPrivate ? 'privateBookmark' : 'sharedBookmark';
                let bookmarkSystemField = {};
                let isDisplay = true;
                if(optionId === 'privateBookmark'){
                    bookmarkSystemField = listSystemField?.find(sysField => sysField.sysField == Constant.ONLY_DRILLDOWN_SYSTEM_FIELD.SYSTEM_FIELD.PRIVATE_BOOKMARK)
                }else{
                    bookmarkSystemField = listSystemField?.find(sysField => sysField.sysField == Constant.ONLY_DRILLDOWN_SYSTEM_FIELD.SYSTEM_FIELD.SHARED_BOOKMARK)
                };

                let hideInProject = Utils.convertJSONDataToObject(
                    bookmarkSystemField.hideInProject
                );

                if (hideInProject[ticketCreatedProjectId] == 1) {
                    isDisplay = false;
                }
                dataDrilldownSelected.push({
                    id: optionId,
                    itemId: bookmarkID,
                    label: `${labelName}/${getSystemFieldNameInDrillDown(optionId)}`,
                    fieldLabel: getSystemFieldNameInDrillDown(optionId),
                    itemLabel: labelName,
                    isBookmark: true,
                    isDisplay: isDisplay,
                    order: order,
                });
            })
        );
    }

    if (!Utils.isEmptyArray(tagFieldList)) {
        await Promise.all(
            tagFieldList.map(async (fieldTag) => {
                let fieldtagId = !Utils.isEmptyArray(Object.keys(fieldTag)) ? Object.keys(fieldTag)[0] : '';
                if (fieldtagId && fieldTag[fieldtagId]) {
                    let fieldTagData = authen ? await getFormById(API, fieldtagId) : await getFormByIdWithoutAuthen(API, fieldtagId);

                    let tagItem = fieldTag[fieldtagId];
                    let tagItemData = {};
                    let prefixFieldTagItem = Utils.getPrefixOfId(tagItem);                    
                    switch (prefixFieldTagItem) {
                        case Constant.ID_PREFIX.KNOWLEDGE:
                            // AI Operator Prompt field
                            if (fieldTagData?.sysField === TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALL_HANDLER) {
                                const getOperatorNameResponse = await getPublicAPI(null, {
                                    getApiType: Constant.GET_API_PUBLIC_TYPE.GET_CALL_HANDLER_DEFAULT_VALUE,
                                    corporationId: fieldTagData?.affiliationOrganization,
                                    defaultValue: tagItem
                                });

                                if (getOperatorNameResponse.success) {
                                    const operatorNameData = Utils.convertJSONDataToObject(getOperatorNameResponse?.payload);
                                    tagItemData.name = operatorNameData?.name;
                                }
                            } else {
                                // master field get ticket title
                                tagItemData = await getTicketById(API, tagItem, null, authen);
                                if (
                                    !tagItemData ||
                                    Utils.isEmptyObject(tagItemData) ||
                                    (tagItemData && tagItemData.id === null)
                                ) {
                                    tagItemData.name = 'undefined name!';
                                    break;
                                }
                                if (tagItemData?.settingTitle && tagItemData?.settingTitle.length) {
                                    tagItemData.name = Utils.getTitle(tagItemData?.settingTitle);  
                                }
                            }

                            break;
                        case Constant.ID_PREFIX.PROJECT:
                            tagItemData = await getProjectById(API, tagItem);
                            break;
                        case Constant.ID_PREFIX.USER:
                            tagItemData = await getUserById(API, tagItem);
                            break;
                        default:
                            tagItemData = authen
                                ? await getFormById(API, tagItem)
                                : await getFormByIdWithoutAuthen(API, tagItem);
                            break;
                    }
                    if (!Utils.isEmptyObject(fieldTagData) && !Utils.isEmptyObject(tagItemData)) {
                        let tagItemName = Utils.convertJSONDataToObject(tagItemData.name);
                        if (prefixFieldTagItem === Constant.ID_PREFIX.USER) {
                            tagItemName = Utils.getUserNameInDrilldown(tagItemData);
                            tagItemData.name = tagItemName;
                        }

                        let fieldLabel = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, fieldTagData.name)
                        let isPdfSystemFile = false
                        if(fieldTagData.definition === Constant.FORM_DEFINITION.SYSTEM){
                            if(fieldLabel == '章' || fieldLabel == '節' || fieldLabel == '項'|| fieldLabel == '目' ){
                                isPdfSystemFile = true
                            }
                        };
                        let hideInProject = {};
                        let isDisplay = true;
                        hideInProject = Utils.convertJSONDataToObject(
                             fieldTagData.hideInProject
                         );
                         if (hideInProject[ticketCreatedProjectId] == 1) {
                             isDisplay = false;
                         }
                        const isDisplayLabelByName = [
                            Constant.ID_PREFIX.TAG,
                            Constant.ID_PREFIX.FIELD,
                            Constant.ID_PREFIX.FORM,
                            Constant.ID_PREFIX.PROJECT
                        ].includes(prefixFieldTagItem);

                        let tagItemDataLabel = isDisplayLabelByName ? Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, tagItemName) : tagItemData.name;

                        const fieldSysField = fieldTagData?.sysField || '';
                        const itemDisplayType = getSelectedTagItemDisplayType(fieldSysField, tagItem, prefixFieldTagItem);

                        dataDrilldownSelected.push({
                            id: fieldtagId,
                            itemId: tagItem,
                            label: `${tagItemDataLabel}/${tagItemDataLabel}`,
                            fieldLabel: fieldLabel,
                            itemLabel: tagItemDataLabel,
                            isTagField: true,
                            displayType: itemDisplayType,
                            displayFieldType: 'FIELD',
                            sysField: fieldSysField,
                            order: 7,
                            isDisplay: isDisplay,
                            isPdfSystemFile
                        });
                    }
                }
            })
        );
    }

    if (!Utils.isEmptyArray(statusFieldList)) {
        let fieldStatus = statusFieldList[0];
        let fieldStatusId = !Utils.isEmptyArray(Object.keys(fieldStatus)) ? Object.keys(fieldStatus)[0] : '';
        if (fieldStatusId && fieldStatus[fieldStatusId]) {
            let statusItem = fieldStatus[fieldStatusId];

            let fieldStatusData = await getFormById(API, fieldStatusId);
            let statusItemData = await getFormById(API, statusItem);

            if (!Utils.isEmptyObject(fieldStatusData) && !Utils.isEmptyObject(statusItemData)) {
                let hideInProject = {};
                let isDisplay = true;
                hideInProject = Utils.convertJSONDataToObject(fieldStatusData.hideInProject);
                if (hideInProject[ticketCreatedProjectId] == 1) {
                    isDisplay = false;
                }
                let statusItemStructure = Utils.convertJSONDataToObject(statusItemData.structure);
                dataDrilldownSelected.push({
                    // id: fieldStatusId,
                    // itemId: statusItemData.id,
                    id: Constant.DUMMY_DRILLDOWN_STATUS_ID,
                    itemId: `${Constant.DUMMY_PREFIX_DRILLDOWN_STATUS_ITEM_ID}${statusItemStructure?.no}`,
                    label: `${Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, statusItemData.name)}/${Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, fieldStatusData.name)}`,
                    fieldLabel: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, fieldStatusData.name),
                    itemLabel: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, statusItemData.name),
                    isStatusField: true,
                    isDisplay: isDisplay,
                    order: 8,
                });
            }
        }
    };

    if(!Utils.isEmptyArray(mcpServerSetting)){
        await Promise.all(
            mcpServerSetting.map(async (mcpId) => {
                if (mcpId.includes(Constant.ID_PREFIX.MCP_CATALOG)) {
                    // Local MCP Catalog case
                    const { catId, prefix } = parseLocalMcpScope(mcpId);
                    const scopeLabel = prefix === LOCAL_MCP_PROJECT_PREFIX ? LOCAL_MCP_PROJECT_PREFIX : LOCAL_MCP_USER_PREFIX;
                    
                    const mcpCatalogDetail = await getMcpCatalogDetailById(catId);
                    let mcpItemName = !Utils.isEmptyObject(mcpCatalogDetail) ? mcpCatalogDetail?.mcpName : '';
                    mcpItemName = `${LOCAL_MCP_LABEL_PREFIX}${scopeLabel}${mcpItemName}`;

                    let optionId = Constant.FORMAT_OPTION_SEARCH.MCP_SERVER_SETTING;
                    let isDisplay = true;
                    if (!Utils.isEmptyArray(listSystemField)) {
                        let mcpSystemField = listSystemField?.find(sysField => sysField.sysField == Constant.AI_AUTO.SYSTEM_FIELD.MCP_SERVER_SETTING);
                        let hideInProject = Utils.convertJSONDataToObject(mcpSystemField?.hideInProject);
                        if (hideInProject?.[ticketCreatedProjectId] == 1) {
                            isDisplay = false;
                        }
                    }
                    dataDrilldownSelected.push({
                        id: optionId,
                        itemId: mcpId,
                        label: `${mcpItemName}/${getSystemFieldNameInDrillDown(optionId)}`,
                        fieldLabel: getSystemFieldNameInDrillDown(optionId),
                        itemLabel: mcpItemName,
                        isMcpServerSetting: true,
                        isDisplay: isDisplay,
                        order: 8.1,
                    });
                } else if (!mcpId.includes(Constant.ID_PREFIX.OPENAI_CONNECTOR_PERSONAL)) {
                    let getMcpServerResponse = await getMCPServerByIdNoValidate({id: mcpId});
                    let mcpItemData = getMcpServerResponse.mcpServerDetail;
                    let mcpItemName = Utils.isEmptyObject(mcpItemData)
                            ? ''
                            : Utils.serverNameWithPrefix(mcpItemData?.serverName, mcpItemData?.type);
                    let order = 8.1;
                    let optionId = Constant.FORMAT_OPTION_SEARCH.MCP_SERVER_SETTING;
                    let mcpSystemField = {};
                    let isDisplay = true;
                    if (!Utils.isEmptyArray(listSystemField)) {
                            mcpSystemField = listSystemField?.find(sysField => sysField.sysField == Constant.AI_AUTO.SYSTEM_FIELD.MCP_SERVER_SETTING)
                        let hideInProject = Utils.convertJSONDataToObject(mcpSystemField.hideInProject);
                        if (hideInProject[ticketCreatedProjectId] == 1) {
                            isDisplay = false;
                        }
                    }
                    dataDrilldownSelected.push({
                        id: optionId,
                        itemId: mcpId,
                        label: `${mcpItemName}/${getSystemFieldNameInDrillDown(optionId)}`,
                        fieldLabel: getSystemFieldNameInDrillDown(optionId),
                        itemLabel: mcpItemName,
                        isMcpServerSetting: true,
                        isDisplay: isDisplay,
                        order: order,
                    });
                } else {
                    let optionId = Constant.FORMAT_OPTION_SEARCH.MCP_SERVER_SETTING;
                    let mcpItemName = '';
                    switch (mcpId) {
                        case Constant.PERSONAL_CONNECTOR_COMMON_ID.DROPBOX:
                            mcpItemName = Utils.serverNameWithPrefix(Constant.PERSONAL_CONNECTOR_SERVICE_NAME.DROPBOX, Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR_PERSONAL);
                            break;
                        case Constant.PERSONAL_CONNECTOR_COMMON_ID.GMAIL:
                            mcpItemName = Utils.serverNameWithPrefix(Constant.PERSONAL_CONNECTOR_SERVICE_NAME.GMAIL, Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR_PERSONAL);
                            break;
                        case Constant.PERSONAL_CONNECTOR_COMMON_ID.GOOGLE_CALENDAR:
                            mcpItemName = Utils.serverNameWithPrefix(Constant.PERSONAL_CONNECTOR_SERVICE_NAME.GOOGLE_CALENDAR, Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR_PERSONAL);
                            break;
                        case Constant.PERSONAL_CONNECTOR_COMMON_ID.GOOGLE_DRIVE:
                            mcpItemName = Utils.serverNameWithPrefix(Constant.PERSONAL_CONNECTOR_SERVICE_NAME.GOOGLE_DRIVE, Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR_PERSONAL);
                            break;
                        case Constant.PERSONAL_CONNECTOR_COMMON_ID.MICROSOFT_TEAM:
                            mcpItemName = Utils.serverNameWithPrefix(Constant.PERSONAL_CONNECTOR_SERVICE_NAME.MICROSOFT_TEAM, Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR_PERSONAL);
                            break;
                        case Constant.PERSONAL_CONNECTOR_COMMON_ID.OUTLOOK_GMAIL:
                            mcpItemName = Utils.serverNameWithPrefix(Constant.PERSONAL_CONNECTOR_SERVICE_NAME.OUTLOOK_GMAIL, Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR_PERSONAL);
                            break;
                        case Constant.PERSONAL_CONNECTOR_COMMON_ID.OUTLOOK_CALENDAR:
                            mcpItemName = Utils.serverNameWithPrefix(Constant.PERSONAL_CONNECTOR_SERVICE_NAME.OUTLOOK_CALENDAR, Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR_PERSONAL);
                            break;
                        case Constant.PERSONAL_CONNECTOR_COMMON_ID.SHAREPOINT:
                            mcpItemName = Utils.serverNameWithPrefix(Constant.PERSONAL_CONNECTOR_SERVICE_NAME.SHAREPOINT, Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR_PERSONAL);
                            break;
                        default:
                            break;
                    };
                    dataDrilldownSelected.push({
                        id: optionId,
                        itemId: mcpId,
                        label: `${mcpItemName}/${getSystemFieldNameInDrillDown(optionId)}`,
                        fieldLabel: getSystemFieldNameInDrillDown(optionId),
                        itemLabel: mcpItemName,
                        isMcpServerSetting: true,
                        isDisplay: true,
                        order: 8.2,
                    });
                }
            })
        );
    };

    dataDrilldownSelected = dataDrilldownSelected.sort((a, b) => {
        return new Date(a.order) - new Date(b.order);
    });

    return dataDrilldownSelected;
}

/**
 * removeDrillDownSelected
 * @param {*} item 
 * @param {*} argsCommon 
 * @returns 
 */
export const removeDrillDownSelected = (item, argsCommon, setIsShowEditTagField) => {
    if (!item.id) {
        return;
    }
    if (item.id === 'form' && setIsShowEditTagField) {
        setIsShowEditTagField(false);
    }
    
    let currentStructure = cloneDeep(argsCommon.viewStructure);
    if (item.isSystemField) {
        let currentSystemFieldDrilldownSelected = cloneDeep(currentStructure.fields);
        let newSystemDrilldownSelected = [];
        if (item.id === 'suffixOfAttachments') {
            newSystemDrilldownSelected = currentSystemFieldDrilldownSelected.filter(field => !(field.hasOwnProperty(item.id) && field[item.id] === item.itemId));
        } else {
            newSystemDrilldownSelected = currentSystemFieldDrilldownSelected.filter(field => !field.hasOwnProperty(item.id));
        }
        
        currentStructure.fields = newSystemDrilldownSelected;
    }

    if (item.isStatusField) {
        currentStructure.statusFields = [];
    }

    if (item.isTagField) {
        let currentTagFieldDrillDownSelected = cloneDeep(currentStructure.tagFields);
        let newTagFieldDrillDownSelected = currentTagFieldDrillDownSelected.filter(field => !(field.hasOwnProperty(item.id) && field[item.id] === item.itemId));
        currentStructure.tagFields = newTagFieldDrillDownSelected;
    }

    if (
        item.id === Constant.FORMAT_OPTION_SEARCH.TICKET_CREATED_PROJECT_ID &&
        Utils.isTypeFunction(argsCommon?.setDestinationPrjId)
    ) {
        argsCommon?.setDestinationPrjId('');
        currentStructure.ticketCreatedProjectId = '';
    }

    if(item.isBookmark){
        let currentBookmarkDrillDownSelected = cloneDeep(currentStructure[item.id]);
        let newBookmarkDrillDownSelected = currentBookmarkDrillDownSelected.filter(option => option?.bookmarkId !== item?.itemId);
        currentStructure[item.id] = newBookmarkDrillDownSelected;
    };

    if(item.isMcpServerSetting){
        let currentMcpServerSettingDrillDownSelected = cloneDeep(currentStructure[item.id]);
        let newMcpServerSettingDrillDownSelected = currentMcpServerSettingDrillDownSelected.filter(mcpId => mcpId !== item?.itemId);
        currentStructure[item.id] = newMcpServerSettingDrillDownSelected;
    };

    if (argsCommon?.setViewStructure) {
        argsCommon?.setViewStructure(currentStructure);
    }
    if(argsCommon?.setViewStructure && argsCommon.setRemovedTagItem) {
        argsCommon.setLastUserAction(LogKibanaConstant.SEARCH_ACTION.TAG_REMOVE)
        argsCommon.setRemovedTagItem({
            tagName: item.itemLabel,
            fieldName: item.fieldLabel
        })
    }
    
    return currentStructure;
}

/**
 * getProjectNameDrillDownDataSelected
 * @param {*} API 
 * @param {*} projectId 
 */
export const getProjectNameDrillDownDataSelected = async (API, projectId) => {
    let currentCorporationId = localStorageUtil.getAffiliationOrganization();
    let name = '';

    let projectData = await getProjectById(API, projectId);
    if (!Utils.isEmptyObject(projectData)) {
        let projectName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, projectData.name);
        if (projectData.affiliationOrganization === currentCorporationId) {
            name = projectName;
        } else {
            let corporationData = await getCorporationById(API, projectData.affiliationOrganization);
            let corporationName = '';
            if (!Utils.isEmptyObject(corporationData)) {
                corporationName = Utils.getCorporationName(Constant.LANGUAGE_TYPE.JP, corporationData);
            }
            // name = `${corporationName} → ${projectName}`;
            name = `${projectName} (${corporationName})`;
        }
    }

    return name;
}


/**
 * getUserNameDrillDownDataSelected
 * @param {*} API 
 * @param {*} userId 
 * @returns 
 */
export const getUserNameDrillDownDataSelected = async (API, userId) => {
    let currentCorporationId = localStorageUtil.getAffiliationOrganization();
    let name = '';

    let userData = await getUserById(API, userId);
    if (!Utils.isEmptyObject(userData)) {
        let userName = Utils.getUserNameInDrilldown(userData);
        name = userName;
        if (userData.affiliationOrganization !== currentCorporationId) {
            let corporationData = await getCorporationById(API, userData.affiliationOrganization);
            if (!Utils.isEmptyObject(corporationData)) {
                let corporationNameSuffixText = Utils.getCorporationNameSuffixText(corporationData);
                if (corporationNameSuffixText) {
                    name = `${userName} (${corporationNameSuffixText})`;
                }
            }
        }
    }

    return name;
}

export const onConfirmChangeForm = async (projectTargetSelected, argsAll) => {
    argsAll.setIsErrorSelected(false);
    if (projectTargetSelected === argsAll.selectedForm) {
        return;
    }

    let infoTabCsv = argsAll.panelList.find(
        p => p.type === Constant.PANEL_TYPE.KNOWLEDGE_UPLOAD_CSV
    );
    
    if(!Utils.isEmptyObject(infoTabCsv) && !argsAll.isLastActive) {
        if (!Utils.isEmptyObject(argsAll.mapping) && infoTabCsv?.tabList[0]?.id === argsAll.tabId) {
            for (const [key, value] of Object.entries(argsAll.mapping)) {
                if (value !== Constant.UPLOAD_CSV_KNOWLEDGE.DEFAULT_SELECTED_MAPPING) {
                    return argsAll.setIsShowPopUpConfirmChangeForm({
                        status: true,
                        projectTargetSelected: projectTargetSelected
                    });
                }
            }
        }
    }
    argsAll?.clearErrors();
    await onChangeFormCsv(argsAll, projectTargetSelected);
}

export const handleOnchangeForm = async (e, argsAll) => {
    if(argsAll.isDraftMode) {
        argsAll.setIsChangeFormDraftMode(true);
    }
    if(argsAll.isEdited) {
        return argsAll.setIsOpenDialogSelectForm({isOpen: true, value: e.target.value});
    }
    await onConfirmChangeForm(e.target.value, argsAll)
};

export const checkIsDisableBtnSentKnowledgeTicket = (argsAll, aiAutoSelectedData, sdautoSelectedData, aiTelephoneSelectedData = {}) => {
    // check selected create ticket type and select form
    if (
        !argsAll.selectedForm ||
        Utils.isEmptyArray(argsAll.fieldListData) ||
        !Utils.isEmptyObject(argsAll.errorCreateKnowledgeTicket)
    ) {
        return true;
    }

    // check setting view/edit permission
    if (
        Utils.isEmptyArray(argsAll.viewPermissions) ||
        Utils.isEmptyArray(argsAll.editPermissions) ||
        Utils.isEmptyString(argsAll.chatPermission)
    ) {
        return true;
    }

    // check input all fields required
    let inputUploadListField = Utils.isEmptyArray(argsAll.fileUploadList) ? argsAll.detailTicket?.attachment : argsAll.fileUploadList;
    if (argsAll.isDuplicate && argsAll.isDraft) {
        inputUploadListField = !Utils.isEmptyArray(argsAll.fileUploadList) ? argsAll.fileUploadList : [];
        argsAll.fileUpdatedList = [];
    }
    let corporationSetting = Utils.convertJSONDataToObject(argsAll?.corporationDetail?.corporationSetting);
    let listChatGptModel = corporationSetting?.listChatGptModel;
    return !isInputAllFieldRequired(argsAll.fieldListData, argsAll.getValuesCreateKnowledgeTicket, inputUploadListField, argsAll?.fileUpdatedList, aiAutoSelectedData, listChatGptModel, sdautoSelectedData, aiTelephoneSelectedData);
}

export const checkIsDisableBtnDraftKnowledgeTicket = (argsAll) => {
    if (
        !argsAll.selectedForm ||
        Utils.isEmptyArray(argsAll.fieldListData)
    ) {
        return true;
    }
    if (argsAll.isChangeFormDraftMode && argsAll.isDraftMode) {
        return false;
    }
    
    // Ticket draft not edit
    if (argsAll.isDraftMode && !argsAll.isEdited) {
        return true;
    }

    return false;
}

export const onSubmitSaveDraftKnowledgeTicket = async (
    tabId,
    panelType,
    formData,
    userDetail,
    corporationDetail,
    panelId,
    argsAll,
    fieldListData,
    aiAutoSelectedData,
    sdautoSelectedData
) => {
    argsAll.setIsLoading(true);

    let requestBody = {};

    let viewPermissions = argsAll.viewPermissions;
    let editPermissions = argsAll.editPermissions;
    let additionalViewPermissions = argsAll.additionalViewPermissions;
    let additionalEditPermissions = argsAll.additionalEditPermissions;
    let chatPermission = argsAll.chatPermission;

    let viewPermissionsSave = viewPermissions.map(p => p.value);
    let editPermissionsSave = editPermissions.map(p => p.value);
    let additionalViewPermissionsSave = getAdditionalPermissionsForSave(additionalViewPermissions);
    let additionalEditPermissionsSave = getAdditionalPermissionsForSave(additionalEditPermissions);

    let ticketType = Constant.TICKET_TYPE.KNOWLEDGE;
    let formListClone = cloneDeep(argsAll.formList);
    let formSelectedId = argsAll.selectedForm;
    let formIndex = Utils.findIndexInArrayById(formSelectedId, formListClone);
    let formTicketType = Constant.FORM_TYPE.KNOWLEDGE;
    if(formIndex !== -1) {
        let formDetail = formListClone[formIndex];
        if (formDetail?.type) {
            formTicketType = formDetail?.type;
        }
        if(formTicketType === Constant.FORM_TYPE.FORM_MASTER) {
            ticketType = Constant.TICKET_TYPE.MASTER_KNOWLEDGE
        }
    }

    if(Utils.isEmptyArray(viewPermissions) || Utils.isEmptyArray(editPermissions) || Utils.isEmptyString(chatPermission)) {
        return;
    }

    argsAll.setIsLoading(true);

    let status = '';
    const statusField = fieldListData.find((fieldData) => fieldData.type === "WORKFLOW");
    if(!Utils.isEmptyObject(statusField)){
        status = statusField.fieldId;
    }

    // convert field to request body
    let fields = await Utils.getCustomFieldValueInFormData(formData, fieldListData, aiAutoSelectedData, sdautoSelectedData);

    // validate exceed max size
    if (validateExceedSizeOfFieldTicket(argsAll.fieldListData, argsAll.setFiledListData, fields, argsAll.setErrorMessageHeader)) {
        argsAll.setIsLoading(false);
        return;
    }

    let uploadFileS3Result = {
        fileListSuccess: [],
        suffixOfAttachments: {},
        listFileError: []
    };

    uploadFileS3Result = await handleUploadFilesForTicket(
        formData,
        argsAll.setFileUploading,
    );

    let fileUploadedDeleted = [];
    if(!Utils.isEmptyArray(argsAll.fileUpdatedList)) {
        fileUploadedDeleted = argsAll.fileUpdatedList.filter(file => file.isDelete === true);
        if(!Utils.isEmptyArray(fileUploadedDeleted)) {
            fileUploadedDeleted = fileUploadedDeleted.map(file => {
                let fileClone = {...file};
                delete fileClone.isDelete;
                delete fileClone.createdAt;
                delete fileClone?.thumbnailInfo;
                return fileClone
            })
        }
    }

    let newFileUpdatedList = cloneDeep(argsAll.fileUpdatedList);
    if(!Utils.isEmptyArray(newFileUpdatedList)) {
        newFileUpdatedList = newFileUpdatedList.map(file => {
            let fileClone = {...file};
            delete fileClone?.isPrivate;
            return fileClone
        })
    }

    if (Utils.isEmptyArray(uploadFileS3Result.fileListSuccess) && Utils.isEmptyObject(uploadFileS3Result.suffixOfAttachments)) {
        let {suffixOfAttachments, listFileUploadSuccess} = createDataListFileDuplicate(newFileUpdatedList);
        uploadFileS3Result.suffixOfAttachments = suffixOfAttachments;
        newFileUpdatedList = listFileUploadSuccess;
    }

    let draftTicketInfo = {
        isSendDraft: argsAll?.isDraft && !argsAll?.isDuplicate ? true : false,
        fileUploadedList: copyFileOfTicketDraftTo(newFileUpdatedList),
        oldDraftTicketId: argsAll?.detailTicket?.id && !argsAll?.isDuplicate ? argsAll?.detailTicket?.id : '',
        fileUploadedDeleted: fileUploadedDeleted
    };

    requestBody = {
        createTicketRequestDto: {
            outline: formData.outline,
            corporationOrigin: corporationDetail.id,
            description: formData.description,
            createUserId: userDetail.id,
            projectOrigin: argsAll.projectInuseDetail?.id,
            projectTarget: argsAll.projectInuseDetail?.id,
            corporationTarget: corporationDetail.id,
            ticketType: ticketType,
            affiliationOrganization: corporationDetail.id,
            affiliationProject: argsAll.projectInuseDetail?.id,
            status: status,
            fields: fields,
            type: argsAll.selectedForm,
            customer: Constant.NA,
            viewPermission: viewPermissionsSave,
            additionalViewPermission: JSON.stringify(additionalViewPermissionsSave),
            editPermission: editPermissionsSave,
            additionalEditPermission: JSON.stringify(additionalEditPermissionsSave),
            chatPermission: chatPermission,
            public: Constant.TICKET_PUBLIC.DRAFT,
            fileListSuccess: uploadFileS3Result.fileListSuccess,
            suffixOfAttachments: JSON.stringify(uploadFileS3Result?.suffixOfAttachments),
            isServicesPDFOfCorpOn: isDisplaySplitPDF(argsAll.corporationDetail, formTicketType),
            ...draftTicketInfo
        }
    };

    const newTicket = await saveDraftTicketAPI(argsAll.API, requestBody);
    argsAll.setIsDraftMode(true);
    argsAll.setIsEdited(false);
    
    if (!newTicket?.id) {
        argsAll.setIsLoading(false);
        return;
    }

    let dataUpdateLastForm = {
        typeLastTicket: Constant.TYPE_LAST_FORM.LAST_FORM_KNOWLEDGE,
        formId: argsAll?.selectedForm,
        projectTargetId: argsAll?.projectInuseDetail?.id,
        corpTargetId: corporationDetail?.id
    }

    await updateUserWorkLastForm(dataUpdateLastForm, argsAll.setUserDetail, argsAll.userDetail);

    //update usingTicket of formList 
    if(formIndex !== -1) {
        let formDetail = formListClone[formIndex];
        let usingTickets = Utils.convertJSONDataToObject(formDetail.usingTickets);

        if (!Utils.isEmptyObject(usingTickets)) {
            if (usingTickets[newTicket.affiliationProject]) {
                usingTickets[newTicket.affiliationProject].push(newTicket.id);
            } else {
                usingTickets[newTicket.affiliationProject] = [newTicket.id];
            }
        } else {
            usingTickets = {};
            usingTickets[newTicket.affiliationProject] = [newTicket.id];
        }

        formListClone[formIndex].usingTickets = JSON.stringify(usingTickets);
    }
    argsAll.setFormList(formListClone);

    removePanelInitData(panelId, tabId, argsAll.panelInitData, argsAll.setPanelInitData);
    argsAll.updatePanelAfterCreateTicket({
        panelId: panelId,
        tabId: tabId,
        panelType: panelType,
        ticketId: newTicket.id,
        ticketOutline: newTicket.outline,
        isDraft: true,
        API: argsAll.API
    });

    argsAll.enqueueSnackbar(buildSnackbarMessage('MSG-CM-SAVE-DRAFT-TICKET-SUCCESS'), {
        variant: 'success',
        autoHideDuration: 3000
    });
    return;
};

export const initDataTicketKnowledgeDraft = (argsAll, currentPanelInitDataRes) => {
    if (!argsAll.detailTicket || Utils.isEmptyObject(argsAll.detailTicket)) return;

    // set setting permissions value
    let dataSettingDefault = {
        viewPermission: argsAll.detailTicket?.viewPermission
            ? argsAll.detailTicket?.viewPermission
            : [],
        editPermission: argsAll.detailTicket?.editPermission
            ? argsAll.detailTicket?.editPermission
            : [],
        additionalViewPermission: argsAll.detailTicket?.additionalViewPermission
            ? argsAll.detailTicket?.additionalViewPermission
            : '',
        additionalEditPermission: argsAll.detailTicket?.additionalEditPermission
            ? argsAll.detailTicket?.additionalEditPermission
            : '',
        chatPermission: argsAll.detailTicket?.chatPermission
    };

    if (!argsAll.isDuplicate) {
        argsAll.setDataSettingDefaults(dataSettingDefault);
    }

    // set form data
    if (argsAll.draftData?.formDetail && argsAll.draftData?.fieldListData) {
        let fieldListData = Utils.convertJSONDataToObject(argsAll.draftData.fieldListData);
        // Form detail
        let formDetail = Utils.convertJSONDataToObject(argsAll.draftData?.formDetail);
        submitOnchangeForm(formDetail.id, argsAll, formDetail, false, fieldListData);

        // Form data
        let cloneCurrentPanelInitData = cloneDeep(argsAll.currentPanelInitData);
        let objFormData =
            cloneCurrentPanelInitData?.formData &&
            !Utils.isEmptyObject(cloneCurrentPanelInitData?.formData)
                ? cloneCurrentPanelInitData?.formData
                : {};
        if (!Utils.isEmptyArray(fieldListData)) {
            fieldListData.forEach(field => {
                if (TmpHiddenSysFieldInTicketDetail.includes(field.sysField)) return;

                const currentFormData = currentPanelInitDataRes?.formData;
                const isFieldEdited =
                    !Utils.isEmptyObject(currentFormData) &&
                    currentFormData.hasOwnProperty(field?.id) &&
                    currentPanelInitDataRes?.isEditedData &&
                    (currentPanelInitDataRes?.argsAll?.displayMode === Constant.DISPLAY_MODE.EDIT ||
                    currentPanelInitDataRes?.displayMode === Constant.DISPLAY_MODE.EDIT)
                

                if (field.type === Constant.FORM_TYPE.FIELD_TAG) {
                    let defaultSelectedTag = [];
                    if (!Utils.isEmpty(field?.defaultValue)) {
                        defaultSelectedTag = field.defaultValue;
                    } 

                    if (isFieldEdited) {
                        defaultSelectedTag = currentFormData[field?.id];
                    }
                    objFormData[field.id] = defaultSelectedTag;
                } else {
                    let fieldValue = field.value;

                    if (isFieldEdited) {
                        fieldValue = currentFormData[field?.id];
                    }
                    objFormData[field.id] = fieldValue;
                }
            });

            cloneCurrentPanelInitData.formData = objFormData;
        }
        argsAll.setCurrentPanelInitData(cloneCurrentPanelInitData);
        argsAll.setTriggerSaveFormData(Date.now().toString());
    }
};

export const submitOnchangeForm = async (
    selectedFormId,
    argsAll,
    formDetail,
    isKeepLoading = false,
    initFieldListData
) => {
    // Reset old value of form, set new form id
    argsAll.setIsLoading(true);
    // User click change form, not init data
    if (!Utils.isEmptyArray(argsAll.fieldListData)) {
        argsAll.resetValuesCreateKnowledgeTicket();
        unregisterField(
            argsAll.fieldListData,
            argsAll.unregisterCreateKnowledgeTicket,
            argsAll.resetValuesCreateKnowledgeTicket
        );

        // Reset attact file
        argsAll.setValueCreateKnowledgeTicket(Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME, []);
        argsAll.setFileUploadList([]);

        // Reset current panel init data
        let cloneCurrentPanelInitData = cloneDeep(argsAll.currentPanelInitData);
        delete cloneCurrentPanelInitData.formData;
        argsAll.setCurrentPanelInitData(cloneCurrentPanelInitData);
        argsAll.setTriggerSaveFormData(Date.now().toString());
        argsAll.setIsEdited(true);
    }
    argsAll.setSelectedForm(selectedFormId);

    let infoTabCsv = argsAll.panelList.find(
        p => p.type === Constant.PANEL_TYPE.KNOWLEDGE_UPLOAD_CSV
    );
    
    if(Utils.isEmptyObject(infoTabCsv)) {
        argsAll.setSelectedFormCsv(selectedFormId);
    }

    if(!Utils.isEmptyObject(infoTabCsv)) {
        if(infoTabCsv?.tabList[0].id === argsAll.tabId) {
            argsAll.setSelectedFormCsv(selectedFormId);
        }
    }
    argsAll.setValueCreateKnowledgeTicket('selectedForm', selectedFormId);
    argsAll.setValueCreateKnowledgeTicket('fileUploadList', []);

    let selectedFormDetail = formDetail;
    if (!selectedFormDetail || Utils.isEmptyObject(selectedFormDetail)) {
        selectedFormDetail = await getFormFromFormListById(selectedFormId);
    }

    const formStructure = Utils.convertJSONDataToObject(selectedFormDetail?.structure);
    let fieldOrderInForm = {};
    if (!Utils.isEmptyObject(formStructure)) {
        for (const [structureKey, structureValue] of Object.entries(formStructure)) {
            if (structureKey && structureValue && structureValue.hasOwnProperty('field')) {
                fieldOrderInForm[structureValue['field']] = parseInt(structureKey);
            }
        }
    }

    if (!Utils.isEmptyObject(selectedFormDetail)) {
        // validate display AI Auto Log
        const isAIAutoForm = Utils.isSystemAIAutoForm(selectedFormDetail);
        const isUsingAIAuto = Utils.isCorporationOnAIAuto(argsAll?.corporationDetail);
        argsAll?.setIsShowAiAutoLog(isAIAutoForm && isUsingAIAuto);

        // validate display SD Auto Log
        if(argsAll?.setIsShowSDautoLog) {
            const isSDAutoForm = selectedFormDetail?.definitionVariant === Constant.FORM_VARIANT.SD_AUTO;
            const isUsingSDAuto = Utils.isCorporationOnSDAuto(argsAll?.corporationDetail);
            argsAll?.setIsShowSDautoLog(isSDAutoForm && isUsingSDAuto);
        }

        if (argsAll?.setIsShowAITelephonePromptLog) {
            const isAITelephonePromptForm =
                selectedFormDetail?.definitionVariant === Constant.FORM_VARIANT.AI_TELEPHONE_PROMPT ||
                selectedFormDetail?.definitionVariant === Constant.FORM_VARIANT.AI_TRAINING_PROMPT ||
                selectedFormDetail?.definitionVariant === Constant.FORM_VARIANT.AI_ASSISTANT_PROMPT;

            const isProjectActiveAITelephoneAgent =
                Utils.isEnableSettingTelephoneAgent(argsAll?.corporationDetail) &&
                argsAll?.detailTicket?.affiliationOrganization === argsAll?.corporationDetail.id;

            argsAll?.setIsShowAITelephonePromptLog(
                isAITelephonePromptForm && isProjectActiveAITelephoneAgent
            );
        }
        
        argsAll.setSelectedFormInfo(selectedFormDetail);
        if (argsAll.setSelectedFormDetail) {
            argsAll.setSelectedFormDetail(selectedFormDetail);
        }
        if (argsAll.setAITelephoneSelectedData) {
            argsAll.setAITelephoneSelectedData(preValue => {
                if (!Utils.isEmptyObject(preValue)) {
                    return {
                        ...preValue,
                        selectedFormDetail
                    };
                }
                return {
                    selectedFormDetail
                };
            });
        }
        let getFieldListResult = [];
        if (!Utils.isEmptyArray(initFieldListData)) {
            getFieldListResult = cloneDeep(initFieldListData);
        } else {
            
            const customFieldList = await getListCustomFiledOfForm(
                formStructure,
                argsAll.API,
                selectedFormDetail.affiliationOrganization
            );
            getFieldListResult = getFormFieldData(formStructure, customFieldList);
        }

        if (
            [Constant.FORM_TYPE.FORM_KNOWLEDGE, Constant.FORM_TYPE.FORM_MASTER].includes(
                selectedFormDetail.type
            )
        ) {
            getFieldListResult = Array.from(getFieldListResult, field => {
                field.structure.publicForCustomer = 3;
                return field;
            });
        }

        getFieldListResult = getFieldListResult.filter(
            x =>
                Number(x.structure.publicForCustomer) !==
                    Constant.SETTING_PUBLIC_FOR_CUSTOMER.HIDE ||
                x.type === Constant.FORM_TYPE.FIELD_WORKFLOW
        );

        // filter field not share for corporation of form
        if (selectedFormDetail.definition !== Constant.FORM_DEFINITION.SYSTEM) {
            getFieldListResult = getFieldListResult.filter(x => {
                // sys field auto pass
                if (
                    (x.definition = Constant.FORM_DEFINITION.SYSTEM) ||
                    x.type === Constant.FORM_TYPE.FIELD_WORKFLOW
                ) {
                    return true;
                }

                // get corporation of form
                let currentCorporationDetailId = argsAll.corporationDetail?.id;

                // field belongs to corporation
                if (x.affiliationOrganization === currentCorporationDetailId) {
                    return true;
                }

                // field is shared
                if (currentCorporationDetailId) {
                    let shareRangeOfField = Utils.convertJSONDataToObject(x.shareRange)
                        ? []
                        : Utils.convertJSONDataToObject(x.shareRange);
                    return shareRangeOfField?.includes(currentCorporationDetailId);
                }
                return true;
            });
            // filter field inactive
            getFieldListResult = getFieldListResult.filter(field => {
                let usingProjectOfField = Utils.convertJSONDataToObject(field.usingProjects);
                return usingProjectOfField?.includes(selectedFormDetail.affiliationProject);
            });
        }

        getFieldListResult = Array.from(getFieldListResult, field => {
            if (
                Number(field.structure.publicForCustomer) ===
                Constant.SETTING_PUBLIC_FOR_CUSTOMER.ONLY_VIEW
            ) {
                field.structure.required = false;
            }

            if (['guestOrg', 'guestProject'].includes(field.sysField)) {
                field.structure.required = true;
            }
            return field;
        });

        getFieldListResult = getFieldListResult
            .filter(field => {
                if (
                    Utils.isSystemFormChatAIPrompt(selectedFormDetail) ||
                    Utils.isSystemAIAutoForm(selectedFormDetail) ||
                    Utils.isSystemSDAutoForm(selectedFormDetail) ||
                    Utils.isSystemBusinessAppForm(selectedFormDetail) ||
                    Utils.isSystemFormAITelephonePrompt(selectedFormDetail) ||
                    Utils.isSystemFormAIAssistantPrompt(selectedFormDetail) ||
                    Utils.isSystemFormAITrainingPrompt(selectedFormDetail) ||
                    Utils.isSystemFormKBoardPrompt(selectedFormDetail) ||
                    Utils.isSystemKBoardKnowledgeForm(selectedFormDetail)
                )
                    return true;
                if (
                    (!field.sysField ||
                        !TmpHiddenSysfieldInCreateTicket.includes(field.sysField)) &&
                    field?.usingProjects?.includes(selectedFormDetail?.affiliationProject)
                )
                    return true;
                return false;
            })
            .sort((a, b) => {
                if (!a.order || !b.order) return 1;
                // attachment always at bottom
                if (a.sysField === 'attachments') return 1;
                if (b.sysField === 'attachments') return -1;

                if (!Utils.isEmptyObject(fieldOrderInForm)) {
                    return fieldOrderInForm[a.id] - fieldOrderInForm[b.id];
                }

                return 1;
            });
        if (argsAll.isDuplicate && argsAll.projectInuseDetail.id !== formDetail.affiliationProject) {
            getFieldListResult = getFieldListResult
                .filter(
                    field => field.publicForCustomer !== Constant.SETTING_FORM_DEFAULT.DO_NOT_SHOW
                )
        }

        if (!Utils.isEmptyArray(initFieldListData)) {
            let newListField = [];
            getFieldListResult.forEach(fieldData => {
                let defaultValue;
                if (
                    fieldData.type === Constant.FORM_TYPE.FIELD_TAG ||
                    fieldData.structure?.UI === Constant.FIELD_UI.DROP_FILE
                ) {
                    defaultValue = [];
                } else {
                    defaultValue = '';
                }

                if (fieldData.defaultValue) {
                    defaultValue = fieldData.defaultValue;
                } else if (fieldData.value) {
                    defaultValue = fieldData.value;
                }

                let fieldDataTmp = {
                    ...fieldData,
                    defaultValue
                };
                if (argsAll.isDraftMode) {
                    fieldDataTmp.structure.publicForCustomer =
                        Constant.SETTING_PUBLIC_FOR_CUSTOMER.EDITABLE;
                }
                newListField.push(fieldDataTmp);
            });
           argsAll.setFiledListData([...newListField]);
        } else {
           argsAll.setFiledListData([...getFieldListResult]);
        }
    }

    if (!isKeepLoading) {
        argsAll.setIsLoading(false);
    }
};

/**
 * 
 * @param {*} event 
 * @param {*} reason 
 * @param {*} argsAll 
 * @returns 
 */
 export const closeCallbackDeleteDraftKnowledgeButton = (event, reason, argsAll) => {
    if (event && reason === 'backdropClick') {
        return false;
    }
    argsAll.setIsOpenDialogConfirmDeleteDraftKnowledge(false);
}

/**
 * 
 * @param {*} argsAll 
 */
export const acceptSoftDeleteDraftKnowledgeButton = (API, detailTicket, currentUserDetail, argsAll) => {
    argsAll.setIsOpenDialogConfirmDeleteDraftKnowledge(false);
    submitSoftDeleteDraft(API, detailTicket, currentUserDetail, argsAll);
}

export const acceptRestoreKnowledgeTicketDraft = (API, detailTicket, currentUserDetail, argsAll) => {
    argsAll.setIsShowDialogRestoreTicket(false);
    submitSoftDeleteDraft(API, detailTicket, currentUserDetail, argsAll, null);
}

export const submitSoftDeleteKnowledgeTicket = async (API, detailTicket, deletedAt, currentUserDetail, argsAll) => {
    let submitSoftDeleteTicketRequestDto = {
        ticketId: detailTicket.id,
        currentUserId: currentUserDetail.id,
        currentUserMail: currentUserDetail.mail,
        corporationId: currentUserDetail.affiliationOrganization,
        updateMethod: Constant.UPDATE_TICKET_METHOD.UPDATE_DELETED_AT,
        ticketType: detailTicket.ticketType,
        deletedAt: deletedAt
    };
    
    return await editTicketData(API, submitSoftDeleteTicketRequestDto);
};

/**
 * 
 * @param {*} args 
 * @returns 
 */
const getPanelType = (args) => {
    let {panelList} = args
    let currentPanelIndex = Utils.findIndexInArrayById(args.panelId, panelList);
    if (currentPanelIndex === -1) return '';
    let currentPanel = panelList[currentPanelIndex];
    return currentPanel.type;
};

/**
 * 
 * @param {*} args 
 * @returns 
 */
const getTicketListType = (args) => {
    return getPanelType(args) === Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL
        ? Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST
        : Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_TICKET_LIST;
};

/**
 * 
 * @param {*} API 
 * @param {*} detailTicket 
 * @param {*} currentUserDetail 
 * @param {*} argsAll 
 */
 export const submitSoftDeleteDraft = (API, detailTicket, currentUserDetail, argsAll, deletedAt = new Date().toISOString()) => {
    argsAll.setIsLoading(true);

    submitSoftDeleteKnowledgeTicket(API, detailTicket, deletedAt, currentUserDetail, argsAll)
        .then(result => {
            if (!result || result?.errorCode === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
                argsAll.setIsLoading(false);
                argsAll.setIsOpenModalReloadPage?.(true);
                return;
            }

            argsAll.setIsLoading(false);
            argsAll.reloadTicketListByPanelType({
                panelType: getTicketListType(argsAll)
                    ? getTicketListType(argsAll)
                    : Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST
            });
            argsAll.enqueueSnackbar(buildSnackbarMessage(deletedAt ? 'MSG-CM-DELETE-CONTENT-SUCCESSFULLY' : 'MSG-CM-RESTORE-CONTENT-SUCCESSFULLY'), {
                variant: 'success',
                autoHideDuration: 3000
            });
            argsAll.reloadPanelAfterSoftDeleteTicketByPanelType({
                panelType: Constant.PANEL_TYPE.KNOWLEDGE_CHATTHREAD,
                id: detailTicket.id
            })

            if (deletedAt) {
                reloadPanelAfterSoftDeleteTicketKnowledge(
                    {...argsAll, setPanelList: argsAll.setPanelListRecoilState},
                    detailTicket.id,
                    result.updatedChildrenTicketIdList,
                    true,
                    deletedAt
                );
            } else {
                //  updatePanelAfterBackToDraft
                argsAll.updatePanelAfterCreateTicket({
                    panelType: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL,
                    componentName: Constant.COMPONENT_NAME.DETAIL_TICKET_DRAFT,
                    tabId: detailTicket.id,
                    isDraft: true,
                    panelId: argsAll.panelId,
                    ticketId: detailTicket.id,
                    ticketOutline: detailTicket.outline,
                    API: API,
                    updatedChildrenTicketIdList: result?.updatedChildrenTicketIdList,
                    isTicketDeleted: false
                })
            }
        })
        .catch(err => {
            argsAll.setIsLoading(false);
            argsAll.reloadTicketListByPanelType({
                panelType: getTicketListType(argsAll)
                    ? getTicketListType(argsAll)
                    : Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST
            });

            argsAll.enqueueSnackbar(buildSnackbarMessage('SYSMSG001'), {
                variant: 'error',
                autoHideDuration: 3000
            });
        })
};

export const handlerShowButtonEditTicket = (value, allArgs, formData, aiTelephoneSelectedData = {}) => {
    let cloneFieldListDefaultData = cloneDeep(allArgs.fieldListDefaultData);
    // filter field is required
    let realRequiredFieldList = cloneFieldListDefaultData.filter(
        field =>
            field.sysField !== Constant.TICKET_DATA_ID.TICKET_ID &&
            !Utils.isEmptyObject(field) &&
            field?.structure?.required
    );

     //filter field is and or and exclude of ai auto event form
     const specialFieldsOfAiAutoEvent = cloneFieldListDefaultData.filter(field =>
        [
            Constant.AI_AUTO.SYSTEM_FIELD.AND,
            Constant.AI_AUTO.SYSTEM_FIELD.OR,
            Constant.AI_AUTO.SYSTEM_FIELD.EXCLUDE
        ].includes(field.sysField)
    );

    let isTelephoneForm = cloneFieldListDefaultData?.some(field => field.sysField?.startsWith(Constant.ID_PREFIX.AI_TELEPHONE_FIELD_ID_PREFIX));
    if (isTelephoneForm) {
        realRequiredFieldList = filterFieldRequiredForTelephone(realRequiredFieldList, aiTelephoneSelectedData);
    } else {
        realRequiredFieldList = filterTagFieldRequired(realRequiredFieldList, allArgs?.aiAutoSelectedData, allArgs?.sdautoSelectedData);
    }

    if (Utils.isEmptyArray(realRequiredFieldList)) {
        allArgs.setIsEditTicket(true);
        return;
    }

    //get all fields edit
    let fields = Utils.getEditTicketData(formData, allArgs.fieldListDefaultData, allArgs.aiAutoSelectedData, allArgs.sdautoSelectedData);
    let valueTags = value;
    let result = false;
    let newFieldList = [];

    // Validate for aiauto_form_event / sdauto_form
    if (
        allArgs?.formDetail?.definition === Constant.FORM_DEFINITION.SYSTEM &&
        [
            Constant.FORM_VARIANT.AI_AUTO.EVENT,
            Constant.FORM_VARIANT.SD_AUTO
        ].includes(allArgs?.formDetail?.definitionVariant)
    ) {
        let isInputAllRequiredValue = true;
        for (const fieldDetail of realRequiredFieldList) {
            for (const property in fields) {
                if (fieldDetail.id === property && fieldDetail?.type === Constant.FORM_TYPE.FIELD_TAG) {
                    let realValue = fields[property];
                    if (!realValue || Utils.isEmptyArray(realValue)) {
                        isInputAllRequiredValue = false;
                        break;
                    }
                }
            }
        }
        return allArgs.setIsEditTicket(isInputAllRequiredValue)
    }

    if (isTelephoneForm) {
        const delayResponseField = realRequiredFieldList.find(
            f => f.sysField === Constant.SYSTEM_FIELD.AI_TELEPHONE_TIME_BASED_DELAY_RESPONSE
        );
        
        if (delayResponseField && isShowTimeBasedDelayResponseField(aiTelephoneSelectedData)) {
            const fieldValue = fields[delayResponseField.id];
            if (fieldValue === null || fieldValue === undefined || fieldValue === '') {
                allArgs.setIsEditTicket(false);
                return;
            }
        }
    }


    // Assign edit value to each required field
    for (let i = 0; i < realRequiredFieldList.length; i++) {
        let element = realRequiredFieldList[i];
        for (const property in fields) {
            if (element.id === property) {
                element.realValue = fields[property];
                newFieldList.push(element);
            }
        }
    }

    // Check if each required field has enough data
    let arrayResult = [];
    for (let index = 0; index < newFieldList.length; index++) {
        let element = newFieldList[index];
        if (
            [
                Constant.FIELD_UI.TEXT,
                Constant.FIELD_UI.NUMBER,
                Constant.FIELD_UI.TEXT_AREA,
                Constant.FIELD_UI.DATE,
                Constant.FIELD_UI.IFRAME,
                Constant.FIELD_UI.URL
            ].includes(element.structure.UI)
        ) {
            if (element?.realValue.toString().trim() !== '') {
                arrayResult.push(true);
                continue;
            }
            arrayResult.push(false);
            break;
        }

        if (Constant.FIELD_UI.FIELD_RICHTEXT === element.structure.UI) {
            const richTextValue = getRichTextFieldContent(element?.realValue)
            let isInputFieldRequired = true;
            if (!richTextValue || richTextValue === '""') {
                isInputFieldRequired = false;
            }
            arrayResult.push(isInputFieldRequired);
        }

        if (Constant.FIELD_UI.TAG === element.structure.UI) {
            const isHasValue = !Utils.isEmptyArray(element?.realValue);
            arrayResult.push(isHasValue)
        }
    }

    if (newFieldList.find(item => item.structure.UI === Constant.FIELD_UI.DROP_FILE)) {
        if (allArgs?.fileUpdatedList?.length > 0 || allArgs?.fileUploadList?.length > 0) {
            arrayResult.push(true);
        } else {
            arrayResult.push(false);
        }
    }

    /**this comment for note 18/12/2024 */
    if (newFieldList.find(item => item.structure.UI === Constant.FIELD_UI.TAG)) {
        if (!allArgs.isTagList) {
            arrayResult.push(true);
        } else if (allArgs.tagListValue.length > 0 && !valueTags) {
            arrayResult.push(true);
        } else if (valueTags && valueTags.length > 0) { // Don't need check to remove default empty item with value = null. Because we will clear it in before steps. ex: MenuTagInPutBase:327
            arrayResult.push(true);
        } else {
            arrayResult.push(false);
        }
    }
    const specialFieldOfAiAutoEventIds = _.map(specialFieldsOfAiAutoEvent, i=> i?.id)
    if(!Utils.isEmptyArray(specialFieldOfAiAutoEventIds)){
        const valuesOfSpecialAiAutoFields = _.map(specialFieldOfAiAutoEventIds, i=>{
            return formData[i] || []
        }).flat()
        const errorValues = _.filter(valuesOfSpecialAiAutoFields, i=> i?.isShow === false)
        if(errorValues.length > 0){
            arrayResult.push(false)
        }
    }
    // Check data and set button display save
    if (!arrayResult.includes(false)) {
        result = true;
    }
    allArgs.setIsEditTicket(result);
}

export const onChangeFormCsv = async (argsAll, projectTargetSelected) => {
    argsAll.setIsEdited(false);
    argsAll.setIsShowPopUpConfirmChangeForm({status: false});
    argsAll.setIsSelectedEditPermissions(false);
    argsAll.setIsSelectedViewPermissions(false);
    argsAll.setFileUploadList([]);
    // argsAll.setSelectedPublicRange(Constant.KNOWLEDGE_PUBLIC_RANGE.ONLY_ME);
    argsAll.setIsOpenDialogSelectForm({isOpen: false, value: ''})
    argsAll.setIsLoading(true);
    if (!Utils.isEmptyArray(argsAll.fieldListData)) {
        unregisterField(argsAll.fieldListData, argsAll.unregisterCreateKnowledgeTicket);

        // Reset current panel init data
        let cloneCurrentPanelInitData = cloneDeep(argsAll.currentPanelInitData);
        delete cloneCurrentPanelInitData.formData;
        argsAll.setCurrentPanelInitData(cloneCurrentPanelInitData);
    }
    argsAll.setSelectedForm(projectTargetSelected);

    let infoTabCsv = argsAll.panelList.find(
        p => p.type === Constant.PANEL_TYPE.KNOWLEDGE_UPLOAD_CSV
    );
    
    if(Utils.isEmptyObject(infoTabCsv)) {
        argsAll.setSelectedFormCsv(projectTargetSelected);
    }

    if(!Utils.isEmptyObject(infoTabCsv)) {
        if(infoTabCsv?.tabList[0].id === argsAll.tabId) {
            argsAll.setSelectedFormCsv(projectTargetSelected);
        }
    }


    argsAll.setValueCreateKnowledgeTicket('selectedForm', projectTargetSelected);
    let selectedFormDetail = await getFormFromFormListById(projectTargetSelected);
    if (!Utils.isEmptyObject(selectedFormDetail)) {
        if (
            Utils.isSystemFormAITelephonePrompt(selectedFormDetail) ||
            Utils.isSystemFormAIAssistantPrompt(selectedFormDetail) ||
            Utils.isSystemFormAITrainingPrompt(selectedFormDetail)
        ) {
            const initIsUsingTelephoneAgent =
                Utils.isEnableSettingTelephoneAgent(argsAll?.corporationDetail);
            if (!initIsUsingTelephoneAgent) {
                argsAll.setIsLoading(false);
                return;
            }
        }

        if (
            isDisplayOptionSearchSynonym(argsAll.corporationDetail, argsAll.projectInuseDetail) &&
            selectedFormDetail.isSynonym
        ) {
            selectedFormDetail = Utils.setDefaultPermissionForSynonymForm(selectedFormDetail)
        }
        
        argsAll.setSelectedFormDetail(selectedFormDetail);
        argsAll.setAITelephoneSelectedData(preValue => {
            if (!Utils.isEmptyObject(preValue)) {
                return {
                    ...preValue,
                    selectedFormDetail
                };
            }
            return {
                selectedFormDetail
            };
        });
        argsAll.setSelectedFormInfo(selectedFormDetail);
        const formStructure = JSON.parse(selectedFormDetail?.structure);
        const customFieldList = await getListCustomFiledOfForm(
            formStructure,
            argsAll.API,
            selectedFormDetail.affiliationOrganization
        );
        let getFieldListResult = getFormFieldData(formStructure, customFieldList);
        // Filter do_not_show_field
        // if (selectedFormDetail.affiliationProject !== argsAll.projectInuseDetail.id && (selectedFormDetail.type === Constant.FORM_TYPE.FORM_KNOWLEDGE || selectedFormDetail.type === Constant.FORM_TYPE.FORM_MASTER)) {
        //     getFieldListResult = getFieldListResult.filter(field => {
        //         if (field?.structure?.publicForCustomer === Constant.SETTING_FORM_DEFAULT.DO_NOT_SHOW) {
        //             return false;
        //         } else {
        //             return true;
        //         }
        //     })
        // }

       getFieldListResult = Array.from(getFieldListResult,(field) => {
            field.structure.publicForCustomer = 3
            return field
        });

        // Get field order in form
        let fieldOrderInForm = {};
        if (!Utils.isEmptyObject(formStructure)) {
            for (const [structureKey, structureValue] of Object.entries(formStructure)) {
                if (structureKey && structureValue && structureValue.hasOwnProperty('field')) {
                    fieldOrderInForm[structureValue['field']] = parseInt(structureKey);
                }
            }
        }
        getFieldListResult = getFieldListResult.filter(field => {
            let isKnowledgeSystemPrompt = false
            if (
                Utils.isSystemFormChatAIPrompt(selectedFormDetail) ||
                Utils.isSystemAIAutoForm(selectedFormDetail) ||
                Utils.isSystemSDAutoForm(selectedFormDetail) || 
                Utils.isSystemBusinessAppForm(selectedFormDetail)||
                Utils.isSystemFormAITelephonePrompt(selectedFormDetail) ||
                Utils.isSystemFormAIAssistantPrompt(selectedFormDetail) ||
                Utils.isSystemFormAITrainingPrompt(selectedFormDetail) ||
                Utils.isSystemFormKBoardPrompt(selectedFormDetail) ||
                Utils.isSystemKBoardKnowledgeForm(selectedFormDetail)
            )
                isKnowledgeSystemPrompt = true;

            if (
                (!field.sysField || !TmpHiddenSysfieldInCreateTicket.includes(field.sysField)) &&
                field?.usingProjects?.includes(selectedFormDetail?.affiliationProject)
            )
                isKnowledgeSystemPrompt = true;
            return isKnowledgeSystemPrompt
        }).sort((a, b) => {
            if (!a.order || !b.order) return 1
            // attachment always at bottom
            if (a.sysField === 'attachments') return 1;
            if (b.sysField === 'attachments') return -1;

            if (!Utils.isEmptyObject(fieldOrderInForm)) {
                return fieldOrderInForm[a.id] - fieldOrderInForm[b.id];
            }
            return 1;
        });
       argsAll.setFiledListData([...getFieldListResult]);
        if (argsAll?.setFlagReset) {
            argsAll.setFlagReset(true);
        }
    }
    argsAll.setIsLoading(false);
}

export const disabledAllField = (panelList, tabId, handleStatus) => {
    let infoTabCsv = panelList.find(
        p => p.type === Constant.PANEL_TYPE.KNOWLEDGE_UPLOAD_CSV
    );
    if(Utils.isEmptyObject(infoTabCsv)) {
        return false
    };

    if(!Utils.isEmptyObject(infoTabCsv)) {
        if(infoTabCsv?.tabList[0].id !== tabId) {
            return false;
        }
    }
    if([
        Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_START,
        Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_SUCCESS,
        Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_PAUSE
    ].includes(handleStatus)) {
        return true;
    }

    return false;
}

export const resetChatPermissionDefault = (originViewPermission, originChatPermission) => {
    if (
        (originViewPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_ORG) ||
        originViewPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.PUBLIC)) && 
        ![Constant.KNOWLEDGE_CHAT_PERMISSION.NO, Constant.KNOWLEDGE_CHAT_PERMISSION.BY_VIEW_PERMISSION].includes(originChatPermission)
    ) {
        return Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_PROJECT
    }

    return originChatPermission
}

export const isDataInputUrlError = (fieldListData, errorList) => {
    let  fieldUrlIds = fieldListData?.filter(fieldData => fieldData.structure.UI === Constant.FIELD_UI.URL).map(field => field.id);
    let isExistUrlError = Object.keys(errorList).some(item => fieldUrlIds.includes(item));
    if (isExistUrlError) {
        return true;
    }
    return false
}

/**
 * 
 * @param {*} corporationId 
 * @param {*} projectId 
 * @param {*} fieldInfo 
 * @param {*} selectedOptionOfField 
 * @returns 
 */
export const getTagItemsByRelatedSystemFieldValue = (
    corporationId,
    projectId,
    userId,
    sysFieldOfField,
    selectedOptionOfField,
    setOptionsOfTagField,
    setIsLoading,
    isFirstRenderFromTicketDetail = false,
    formsInCorporation = [],
    fieldsInCorporation = [],
    projectsInCorporation = [],
    corporationInuseDetail = null
) => {
    if (!setOptionsOfTagField) return false;
    let tagItems = [];
    switch (sysFieldOfField) {
        case Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE:{
            setIsLoading(true);
            getFormsByTicketTypeWithAnyValue(
                corporationId,
                projectId,
                selectedOptionOfField?.sysField,
                formsInCorporation,
                corporationInuseDetail
            )
                .then(result => {
                    setOptionsOfTagField(preValue => {
                        if (
                            _.differenceBy(
                                preValue[Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE],
                                result,
                                'id'
                            ).length == 0 &&
                            preValue[Constant.AI_AUTO.SYSTEM_FIELD.AND]?.length > 0 &&
                            isFirstRenderFromTicketDetail
                        ){
                            return preValue;
                        }

                        return {
                            ...preValue,
                            [Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE]: result,
                            [Constant.AI_AUTO.SYSTEM_FIELD.AND]: [],
                            [Constant.AI_AUTO.SYSTEM_FIELD.OR]: [],
                            [Constant.AI_AUTO.SYSTEM_FIELD.EXCLUDE]: []
                        };
                    });
                })
                .catch(err => {
                    console.log('error query forms', err);
                }).finally(()=>{
                    setIsLoading(false);
                })
            break;
        }
        case Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE:{
            setIsLoading(true);
            getDataForAndOrExcludeFieldByFormId(
                corporationId,
                projectId,
                userId,
                selectedOptionOfField?.value,
                formsInCorporation,
                fieldsInCorporation,
                projectsInCorporation
            )
                .then(result => {
                    setOptionsOfTagField(preValue => {
                        return {
                            ...preValue,
                            [Constant.AI_AUTO.SYSTEM_FIELD.AND]: result,
                            [Constant.AI_AUTO.SYSTEM_FIELD.OR]: result,
                            [Constant.AI_AUTO.SYSTEM_FIELD.EXCLUDE]: result
                        };
                    });
                })
                .catch(err => {
                    console.log('error items forms', err);
                })
                .finally(() => {
                    setIsLoading(false);
                });
                break;
        }
        case Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER:
            setOptionsOfTagField(preValue => {
                return {
                    ...preValue,
                    [Constant.AI_AUTO.SYSTEM_FIELD.CHAT_THREAD_TYPE_TRIGGER]: new Date().getTime() // for trigger
                };
            });
            break;
        default:
    }

    return tagItems;
};

const getFormsByTicketTypeWithAnyValue = async (corporationId, projectId, anyValue, formsInCorporation = [], corporationInuseDetail = null) => {
    let selectedTicketType;
    switch (anyValue) {
        case Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.QA:
            selectedTicketType = Constant.FORM_TYPE.FORM_REQ_QA;
            break;
        case Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.NOTICE:
            selectedTicketType = Constant.FORM_TYPE.FORM_REQ_NOTICE;
            break;
        case Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.TASK:
            selectedTicketType = Constant.FORM_TYPE.FORM_TASK;
            break;
        case Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.EMAIL:
            selectedTicketType = Constant.FORM_TYPE.EMAIL_FORMAT;
            break;
        case Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.KNOWLEDGE:
            selectedTicketType = Constant.FORM_TYPE.FORM_KNOWLEDGE;
            break;
        case Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.TELEPHONE:
            selectedTicketType = Constant.FORM_TYPE.TELEPHONE_FORMAT;
            break;
        default:
    }

    const forms = await getFormsByTicketTypeOfCorporationAndProjectInuse(
        corporationId,
        projectId,
        selectedTicketType,
        formsInCorporation,
        corporationInuseDetail
    );
    return forms || []
};

const getFormsByTicketTypeOfCorporationAndProjectInuse = async (
    corporationId,
    projectId,
    ticketType,
    formsInCorporation = [],
    corporationInuseDetail = null
) => {
    //form list atom is not existed. query form list of project.
    if (formsInCorporation?.length === 0 || !formsInCorporation || corporationId !== corporationInuseDetail?.id) {
        formsInCorporation = await getFormListByProject(null, corporationId, projectId);
    }

    const formsOfProjectInuse = formsInCorporation.filter(form => {
        if (ticketType === Constant.FORM_TYPE.TELEPHONE_FORMAT) {
            return form?.usingProjects?.includes(projectId) && form?.definitionVariant === Constant.FORM_VARIANT.TELEPHONE_FORMAT
        }
        if (ticketType === Constant.FORM_TYPE.FORM_REQ_QA) {
            return form?.definitionVariant === Constant.FORM_VARIANT.TELEPHONE_FORMAT
                ? false
                : form?.usingProjects?.includes(projectId) && form?.type === Constant.FORM_TYPE.FORM_REQ_QA;
        }
        return form?.usingProjects?.includes(projectId) && form?.type === ticketType
    });

    if (formsOfProjectInuse?.length === 0) return [];

    let formList = sortListByOrder(formsOfProjectInuse, projectId);
    // Sort with 'system' items on top
    formList = formList.sort((a, b) => {
        if (
            a?.definition === Constant.FORM_DEFINITION.SYSTEM &&
            b?.definition === Constant.FORM_DEFINITION.USER
        ) {
            return -1; // a comes before b
        }
        if (
            a?.definition === Constant.FORM_DEFINITION.USER &&
            b?.definition === Constant.FORM_DEFINITION.SYSTEM
        ) {
            return 1; // b comes before a
        }
        return 0; // No change in order for items of the same type
    });
    return formList;
};

const getDataForAndOrExcludeFieldByFormId = async (
    corporationId,
    projectId,
    userId,
    formId,
    formsInCorporation = [],
    fieldsInCorporation = [],
    projectsInCorporation = []
) => {
    if (!corporationId || !projectId || !formId) return [];
    let formDetail = {}

    formDetail = _.find(formsInCorporation, form => form?.id === formId);
    
    if (!formDetail){
        formDetail = await getFormById(null, formId);
    }

    if (Utils.isEmptyObject(formDetail)) return [];

    if (formDetail?.definitionVariant === Constant.FORM_VARIANT.TELEPHONE_FORMAT) {
        formDetail = {
            ...formDetail,
            type: Constant.FORM_TYPE.TELEPHONE_FORMAT // override form type
        }
    }

    const PROJECT_TYPES_DISPLAY_IN_FIELD = [Constant.PROJECT_TYPE.GENERAL];
    const FORM_TYPES_NEED_GET_WORK_FOLLOW_FIELD = [
        Constant.FORM_TYPE.FORM_REQ_QA,
        Constant.FORM_TYPE.FORM_TASK,
        Constant.FORM_TYPE.EMAIL_FORMAT,
    ];
    let result = [];

    /**
     * get fields list in form. start
     */
    const formStructure = Utils.convertJSONDataToObject(formDetail?.structure);
    const fieldIdsOfForm = _.map(Object.values(formStructure), i => i?.field).filter(i => i);

    let fieldsListOfForm = _.filter(fieldsInCorporation, field =>
        fieldIdsOfForm?.includes(field?.id)
    );

    if (
        (fieldsInCorporation?.length === 0 || !fieldsInCorporation) &&
        fieldsListOfForm?.length !== fieldIdsOfForm?.length
    ) {
        fieldsListOfForm = await getFieldListInForm(
            null,
            formDetail?.affiliationOrganization,
            fieldIdsOfForm
        );
    }
    const NOT_QUERY_TAG_FIELD_SYS_FIELDS = [
        Constant.SYSTEM_FIELD.PERSON_IN_CHARGE,
        TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALL_HANDLER,
        TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALLER_LANGUAGE,
        TelephoneConstant.TELEPHONE.SYSTEM_FIELD.RECEIVER_LANGUAGE,
        TelephoneConstant.TELEPHONE.SYSTEM_FIELD.AI_OPERATOR_PROMPT,
    ];
    // query fields in form
    //normal tag fields
    const tagFieldsInForm = _.filter(
        fieldsListOfForm,
        field =>
            field?.type === Constant.FORM_TYPE.FIELD_TAG &&
            field?.definition !== Constant.FORM_DEFINITION.SYSTEM_MASTER_FIELD &&
            !NOT_QUERY_TAG_FIELD_SYS_FIELDS.includes(field.sysField)
    );
    //master tag fields
    const masterTagFieldsInForm = _.filter(
        fieldsListOfForm,
        field =>
            field?.type === Constant.FORM_TYPE.FIELD_TAG &&
            field?.definition === Constant.FORM_DEFINITION.SYSTEM_MASTER_FIELD
    );

    // mapping field ids to query items theirs
    const tagFieldIds =  _.map(tagFieldsInForm, tagField => {
        return tagField?.id
    });

    // queries master tag items
    const userInfoToQueryMasterField = {
        userId: userId,
        projectInuse: projectId,
        organizationInuse: corporationId
    };
    const queriesMasterTagItemInForm = _.map(masterTagFieldsInForm, masterField => {
        return queryListMasterKnowledgeTicketOfForm(
            null,
            masterField?.affiliationOrganization,
            masterField?.affiliationProject,
            masterField?.relatedMasterForm,
            userInfoToQueryMasterField
        );
    });

    //query tag items.
    const tagItems = await getTagItemsByParentFieldIds(tagFieldIds)
    //query master tag items
    const masterTagItemsByClusterFields = await Promise.all(queriesMasterTagItemInForm);
    //rename tag items
    const renamedTagItems = renameTagItemToStashFormat(tagItems, tagFieldsInForm, projectId);
    //rename master tag items
    const renamedMasterTagItems = renameMasterTagItemToStashFormat(
        masterTagItemsByClusterFields,
        masterTagFieldsInForm
    );
    result = _.concat(result, renamedTagItems, renamedMasterTagItems);
    /**
     * get all tag items in form. end
     */
    switch (formDetail?.type) {
        case Constant.FORM_TYPE.FORM_REQ_QA:
        case Constant.FORM_TYPE.FORM_REQ_NOTICE: {
            // get projects in corp and b2b project customer of project inuse. filter project inuse
            if (projectsInCorporation?.length == 0 || !projectsInCorporation) {
                projectsInCorporation = await getAllProjectListInCorporation(null, corporationId);
            }
            let b2bCustomersOfProject = await Promise.all([
                getActiveB2BCustomerProjectListOfProject(
                    null,
                    projectId,
                    true,
                    Constant.ACTIVE_FLAG.ACTIVE
                ),
                getActiveB2BCustomerProjectListOfProject(
                    null,
                    projectId,
                    true,
                    Constant.ACTIVE_FLAG.INACTIVE
                )
            ]);
            b2bCustomersOfProject = _.flatten(b2bCustomersOfProject);
            const projectsInCorp = _.filter(
                [...projectsInCorporation, ...b2bCustomersOfProject],
                project => {
                    let isValidProject = true;
                    // if form qa. we will filter project inuse
                    if (formDetail?.type === Constant.FORM_TYPE.FORM_REQ_QA) {
                        isValidProject = project?.id !== projectId;
                    }

                    return (
                        isValidProject &&
                        (project?.orgActive
                            ? project?.orgActive === Constant.CORPORATION_ACTIVE.ACTIVE
                            : !!project) &&
                        project?.active === Constant.ACTIVE_FLAG.ACTIVE
                    );
                }
            ).map(flattenedProject => {
                if (
                    flattenedProject?.active === Constant.ACTIVE_FLAG.ACTIVE &&
                    _.includes(PROJECT_TYPES_DISPLAY_IN_FIELD, flattenedProject?.type)
                ) {
                    return {
                        ...flattenedProject,
                        isShow: true
                    };
                }
                return {
                    ...flattenedProject,
                    isShow: false
                };
            });
            result = _.concat(
                result,
                renameDBRecordsToStashFormatByFormType(projectsInCorp, formDetail?.type)
            );
            break;
        }
        case Constant.FORM_TYPE.FORM_TASK:
            break;
        case Constant.FORM_TYPE.EMAIL_FORMAT:
            result = _.concat(
                result,
                fakeConstantOptions(
                    Constant.AI_AUTO.SENDER_MAIL,
                    Constant.AI_AUTO.SPECIAL_LABEL_TAG_OPTIONS.EMAIL_FORM_FIELD_PROJECT
                )
            );
            break;
        case Constant.FORM_TYPE.FORM_KNOWLEDGE:
            break;
        case Constant.FORM_TYPE.TELEPHONE_FORMAT: {
            // 1. get field: telephone_call_status
            const fieldTelephoneCallStatus = fieldsListOfForm.find(field =>
                field.sysField === TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALL_STATUS
            );
            if (fieldTelephoneCallStatus) {
                result = _.concat(
                    result,
                    renameDBRecordsToStashFormatByFormType(fieldTelephoneCallStatus.itemList, formDetail?.type)
                );
            }

            // 2. Filter out TRAINING mode (not shown in AI training UI)
            result = result.filter(item => {
                return item?.sysField !== TelephoneConstant.TELEPHONE_CALL_MODE.TRAINING;
            });
            break;
        }
        default:
            break;
    }

    /**
     * get field workFollow (status) and its items. start
     */
    if (FORM_TYPES_NEED_GET_WORK_FOLLOW_FIELD.includes(formDetail?.type)) {
        let statusFieldInForm = _.find(
            fieldsInCorporation,
            field =>
                field?.affiliationProject === projectId &&
                field?.type === Constant.FORM_TYPE.FIELD_WORKFLOW
        );

        if (!statusFieldInForm) {
            [statusFieldInForm] = await getFormFieldWithCondition(
                corporationId,
                projectId,
                Constant.FORM_USAGE.FIELD,
                Constant.FORM_TYPE.FIELD_WORKFLOW,
                Constant.FORM_DEFINITION.USER
            );
        }

        // queries items of workFollow field
        const statusListOfWorkFollowField = await getTagItemsByParentFieldId([
            statusFieldInForm?.id
        ]);

        result = _.concat(
            result,
            renameDBRecordsToStashFormatByFormType(statusListOfWorkFollowField, formDetail?.type)
        );
    }
    /**
     * get field workFollow (status) and its items. end
     */
    result = _.orderBy(result, ['sortByDefinition'], ['asc']);

    if (formDetail?.type === Constant.FORM_TYPE.TELEPHONE_FORMAT) {
        return result;
    }

    /**
     * all file type, system allow attach
     * I'm mapping data like a form field object
     */
    const isAttachmentFieldInForm = _.some(
        fieldsListOfForm,
        i => i?.sysField === Constant.SYS_FIELD.ATTACHMENTS
    );
    const fileExtensions = fakeConstantOptions(
        Constant.AI_AUTO.FILE_EXTENSIONS,
        Constant.AI_AUTO.SPECIAL_LABEL_TAG_OPTIONS.FILE_EXTENSION,
        isAttachmentFieldInForm
    );
    result = _.concat(result, fileExtensions);

    /**
     * MCP Server Setting field
     * show this field in AiAuto, Chat AI Prompt, AI Assistant Prompt and Business App forms
     */
    let isMcpSupportForm =
        Utils.isSystemAIAutoForm(formDetail) ||
        Utils.isSystemFormChatAIPrompt(formDetail) ||
        Utils.isSystemFormAIAssistantPrompt(formDetail) ||
        Utils.isSystemBusinessAppForm(formDetail);
    let mcpServerList = [];
    
    if (isMcpSupportForm) {
        const corporationDetail = await getCorporationById(null, corporationId);
        const corporationSetting = Utils.convertJSONDataToObject(corporationDetail?.corporationSetting);
        const isUsingMCPServer = 
            corporationDetail?.contractType === Constant.CORPORATION_CONTRACT_TYPE.PREMIUM &&
            corporationDetail?.limitValue?.mcpServer === Constant.STATUS_SERVICE_PERMISSION.ON &&
            corporationSetting?.usingMCPServer === Constant.STATUS_SERVICE_PERMISSION.ON;
    
        if (isUsingMCPServer) {
            try {
                mcpServerList = await getMcpServerListByProject(projectId, userId, corporationId);
                
                if (!Utils.isEmptyArray(mcpServerList)) {
                    const mcpOptions = mcpServerList.map((server, idx) => ({
                        id: server.id,
                        name: JSON.stringify({
                            jp: {
                                A: 'F',
                                text: displayTitleByItemSlashField(Utils.serverNameWithPrefix(server.serverName, server.type), Constant.SYSTEM_FIELD_NAME.MCP_SERVER_SETTING)
                            }
                        }),
                        sortByDefinition: idx,
                        isShow: true,
                        sysField: Constant.SYS_FIELD.MCP_SERVER_SETTING
                    }));
                    
                    result = _.concat(result, mcpOptions);
                }

                // Add local MCP options for search fields
                const localMcpList = await getLocalMcpListForProject(corporationId, projectId, userId).catch(() => []);
                if (!Utils.isEmptyArray(localMcpList)) {
                    const localMcpOptions = localMcpList
                        .map((item, idx) => {
                            const { prefix } = parseLocalMcpScope(item.catId);
                            const scopeLabel = prefix === LOCAL_MCP_PROJECT_PREFIX ? LOCAL_MCP_PROJECT_PREFIX : LOCAL_MCP_USER_PREFIX;
                            const displayName = `${LOCAL_MCP_LABEL_PREFIX}${scopeLabel}${item.mcpName}`;
                            return {
                                id: item.catId,
                                name: JSON.stringify({
                                    jp: {
                                        A: 'F',
                                        text: displayTitleByItemSlashField(displayName, Constant.SYSTEM_FIELD_NAME.MCP_SERVER_SETTING)
                                    }
                                }),
                                sortByDefinition: (mcpServerList?.length || 0) + idx,
                                isShow: true,
                                sysField: Constant.SYS_FIELD.MCP_SERVER_SETTING
                            };
                        });
                    result = _.concat(result, localMcpOptions);
                }
            } catch (error) {
                console.log('Error loading MCP servers for AND/OR/EXCLUDE fields:', error);
            }
        }

        // Add personal connector services for Chat AI Prompt form
        if (Utils.isSystemFormChatAIPrompt(formDetail)) {
            const personalConnectorOptions = Object.values(Constant.PERSONAL_CONNECTOR_SERVICE_NAME).map((serviceName, idx) => {
                const serviceId = Object.keys(Constant.PERSONAL_CONNECTOR_SERVICE_NAME).find(
                    key => Constant.PERSONAL_CONNECTOR_SERVICE_NAME[key] === serviceName
                );
                const commonId = Constant.PERSONAL_CONNECTOR_COMMON_ID[serviceId];
                const serverName = Utils.serverNameWithPrefix(
                    serviceName,
                    Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR_PERSONAL
                );
                
                return {
                    id: commonId,
                    name: JSON.stringify({
                        jp: {
                            A: 'F',
                            text: displayTitleByItemSlashField(serverName, Constant.SYSTEM_FIELD_NAME.MCP_SERVER_SETTING)
                        }
                    }),
                    sortByDefinition: mcpServerList?.length ? mcpServerList.length + idx : idx,
                    isShow: true,
                    sysField: Constant.SYS_FIELD.MCP_SERVER_SETTING
                };
            }).sort((a, b) => {
                const nameA = Utils.convertJSONDataToObject(a.name)?.jp?.text || '';
                const nameB = Utils.convertJSONDataToObject(b.name)?.jp?.text || '';
                return nameA.localeCompare(nameB);
            });
            
            result = _.concat(result, personalConnectorOptions);
        }
    }
    if (Utils.isSystemFormKBoardPrompt(formDetail)) {
        result = result.filter(
            item => item?.sysField !== Constant.AI_SYSTEM_FIELD_TARGET_OPTION_TAGS.EXTERNAL
        );
    }
    return result;
};

/**
 * rename tag items to format tagItemName/fieldName
 * @param {*} pureTagItems 
 * @param {*} affiliationFieldRecords 
 */
export const renameTagItemToStashFormat = (pureTagItems, tagFieldRecords, projectId) => {
    return _.chain(pureTagItems)
        .map(tagItem => {
            const affiliationField = _.find(tagFieldRecords, tagField => {
                // in some case tag items of sysField, affiliationField of it is empty. So i must be get its name from SystemField.
                if (
                    Utils.isEmptyString(tagItem?.affiliationField) &&
                    tagField?.definition === Constant.FORM_DEFINITION.SYSTEM
                ) {
                    const tagItemConstantRecord = _.find(
                        systemField,
                        i => i?.id === tagItem?.sysField
                    );
                    return tagField?.sysField === tagItemConstantRecord?.affiliationField;
                }

                return tagField?.id === tagItem?.affiliationField;
            });

            const tagItemName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, tagItem?.name) || Utils.convertJSONDataToObject(tagItem?.name);
            let sortByDefinition = tagItem?.definition === Constant.FORM_DEFINITION.SYSTEM ? 0 : 1

            const tagFieldName = Utils.getTextByLanguage(
                Constant.LANGUAGE_TYPE.JP,
                affiliationField?.name
            );
            //convert data when tag got form els. using for spec https://new.redmine.ominext.com/issues/184758#note-14
            let tagStructure = Utils.convertJSONDataToObject(tagItem?.structure);
            if (typeof tagStructure === 'string') {
                tagStructure = Utils.convertJSONDataToObject(tagStructure);
            }

            return {
                ...tagItem,
                name: {
                    jp: { A: 'F', text: displayTitleByItemSlashField(tagItemName, tagFieldName) }
                },
                sortDefinedKey: tagItem?.definition == Constant.FORM_DEFINITION.SYSTEM ? 0 : 1,
                sortKey: tagItemName,
                sortParentKey: tagFieldName,
                isShow: tagStructure?.isShowItemInTicket && _.includes(affiliationField?.usingProjects, projectId),
                sortByDefinition
            };
        })
        .orderBy(['sortParentKey', 'sortKey' ], ['asc', 'asc'])
        .value();
};

/**
 * mapping name of ticket with field name with format. ticket title/master field name
 * @param {*} pureClusterMasterTagItems items are ticket info
 * @param {*} masterFields master field info
 * @returns 
 */
export const renameMasterTagItemToStashFormat = (pureClusterMasterTagItems, masterFields) => {
    return _.chain(pureClusterMasterTagItems)
        .flatMap((clusterMasterTagItem, clusterIdx) => {
            return _.map(clusterMasterTagItem, masterTagItem => {
                const nameOfMasterItem = _.join(_.map(masterTagItem?.settingTitle, 'text'), ' ');
                const masterFieldOfThisCluster = _.nth(masterFields, clusterIdx);
                const nameOfMasterField = Utils.getTextByLanguage(
                    Constant.LANGUAGE_TYPE.JP,
                    masterFieldOfThisCluster?.name
                );
                return {
                    ...masterTagItem,
                    name: {
                        jp: {
                            A: 'F',
                            text: displayTitleByItemSlashField(nameOfMasterItem, nameOfMasterField)
                        }
                    },
                    sortKey: nameOfMasterItem,
                    sortParentKey: nameOfMasterField,
                    isShow: masterTagItem?.userHasViewPermission,
                    sortByDefinition: 1
                };
            });
        })
        .orderBy(['sortParentKey', 'sortKey'], ['asc', 'asc'])
        .value();
};

/**
 * rename tag items to format tagItemName/fieldName
 * @param {*} pureRecords 
 * @param {*} formType 
 * @returns 
 */
export const renameDBRecordsToStashFormatByFormType = (pureRecords, formType) => {
    let fieldName = '';
    const firstRecord = _.first(pureRecords);
    const prefixOfRecord = Utils.getPrefixOfId(firstRecord?.id);

    switch (formType) {
        case Constant.FORM_TYPE.FORM_REQ_QA:
            fieldName = Constant.AI_AUTO.SPECIAL_LABEL_TAG_OPTIONS.QA_TICKET_PROJECT;
            break;
        case Constant.FORM_TYPE.FORM_REQ_NOTICE:
            fieldName = Constant.AI_AUTO.SPECIAL_LABEL_TAG_OPTIONS.NOTICE_TICKET_PROJECT;
            break;
        case Constant.FORM_TYPE.TELEPHONE_FORMAT:
            fieldName = Constant.AI_AUTO.SPECIAL_LABEL_TAG_OPTIONS.TELEPHONE_CALL_STATUS;
            break;
        default:
    }

    //if they are status field records
    if (
        prefixOfRecord === Constant.ID_PREFIX.STATUS &&
        firstRecord?.type === Constant.FORM_TYPE.FIELD_WORKFLOW
    ) {
        fieldName = Constant.AI_AUTO.SPECIAL_LABEL_TAG_OPTIONS.STATUS
    }

    return _.chain(pureRecords)
        .map(record => {
            let recordName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, record?.name) || Utils.convertJSONDataToObject(record?.name);
            let sortKey = recordName
            let sortByDefinition = record?.definition === Constant.FORM_DEFINITION.SYSTEM ? 0 : 1

            if (!Utils.isEmptyString(record?.orgName))
                recordName = `${recordName} (${record?.orgName})`;

            if (prefixOfRecord === Constant.ID_PREFIX.STATUS) {
                const structureOfItem = Utils.convertJSONDataToObject(record?.structure)
                sortKey = structureOfItem?.no
                sortByDefinition = 0
            }

            if (prefixOfRecord === Constant.ID_PREFIX.PROJECT) {
                sortByDefinition = 0
            }

            return {
                ...record,
                name: { jp: { A: 'F', text: displayTitleByItemSlashField(recordName, fieldName) } },
                sortKey,
                sortParentKey: record?.orgName,
                sortByDefinition
            };
        })
        .orderBy(['sortParentKey', 'sortKey'], ['asc', 'asc'])
        .value();
};

export const displayTitleByItemSlashField = (itemName, fieldName) => {
    if (Utils.isEmptyString(fieldName)) return itemName;
    return `${itemName}/${fieldName}`;
};

export const fakeConstantOptions = (arr, fieldName, isShow = true) => {
    return _.chain(arr)
        .map((i, idx) => {
            return {
                id: i?.id,
                name: JSON.stringify({
                    jp: {
                        A: 'F',
                        text: displayTitleByItemSlashField(i?.name, fieldName)
                    }
                }),
                definition: Constant.FORM_DEFINITION.SYSTEM,
                hitNumber: idx,
                sysField: null,
                sortKey: i?.name,
                sortParentKey: fieldName,
                isShow,
                sortByDefinition: 0
            };
        })
        .orderBy(['sortParentKey', 'sortKey'], ['asc', 'asc'])
        .value();
};

/**
 * isShowFieldEventTypeChatThread
 * show and display field_event_type_chat_thread 
 * @param {*} aiAutoSelectedData 
 * @returns 
 */
export const isShowFieldEventTypeChatThread = aiAutoSelectedData => {
    if (
        !aiAutoSelectedData ||
        Utils.isEmptyObject(aiAutoSelectedData) ||
        !aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER] ||
        Utils.isEmptyArray(aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER]) ||
        !aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE] ||
        Utils.isEmptyArray(aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE])
    ) {
        return false;
    }

    if (!Utils.isEmptyArray(aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE])) {
        if (
            [
                Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.TASK,
                Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.KNOWLEDGE
            ].includes(
                aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE][0]?.sysField
            )
        ) {
            return false;
        }
    }

    let currentAiEventTypeSelected = aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER];

    let isSelectedChatthreadValid = currentAiEventTypeSelected.find(selectedTag =>
        [
            Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER_CHAT_OUTSIDE,
            Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER_CHAT_IN_PROJECT
        ].includes(selectedTag?.sysField)
    );

    return !Utils.isEmptyObject(isSelectedChatthreadValid);
};

export const isShowFieldCallApiTarget = sdautoSelectedData => {
    if (!sdautoSelectedData || Utils.isEmptyObject(sdautoSelectedData)) return false;

    const callApiSettingOpts = sdautoSelectedData[Constant.SD_AUTO.SYSTEM_FIELD.SDAUTO_CALL_SCRIPT_API_SETTING];
    if (!callApiSettingOpts || Utils.isEmptyArray(callApiSettingOpts)) return false;

    const callApiSelected = callApiSettingOpts[0]?.sysField;
    if (!callApiSelected) return false;
    
    return callApiSelected === Constant.SD_AUTO.SYSTEM_FIELD.SDAUTO_CALL_SCRIPT_API_SETTING_ON
}


/**
 * validateShowTagItemEventTypeChatThread
 * show and hide some item in field_event_type_chat_thread
 * @param {*} itemData 
 * @param {*} aiAutoSelectedData 
 * @returns 
 */
export const validateShowTagItemEventTypeChatThread = (itemData, aiAutoSelectedData = {}) => {
    if (Utils.isEmptyObject(aiAutoSelectedData)) return false;
    if (!isShowFieldEventTypeChatThread(aiAutoSelectedData)) return false;

    let isShow = false;
    let currentAiEventTypeSelected =
        aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER];
    let currentAiTicketTypeSelected =
        aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE];

    if (
        Utils.isEmptyArray(currentAiEventTypeSelected) ||
        Utils.isEmptyArray(currentAiTicketTypeSelected)
    )
        return false;

    let selectedTicketTypeItem = currentAiTicketTypeSelected[0];

    if (
        ![
            Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.QA,
            Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.NOTICE,
            Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.EMAIL,
            Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.TELEPHONE
        ].includes(selectedTicketTypeItem?.sysField)
    ) {
        return false;
    }

    switch (itemData?.sysField) {
        case Constant.AI_AUTO.CHAT_THREAD_TYPE_OPTION.THREAD_CUSTOMER:
            if (
                [
                    Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.QA,
                    Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.EMAIL,
                    Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.TELEPHONE
                ].includes(selectedTicketTypeItem?.sysField)
            ) {
                isShow = true;
            }

            if (
                selectedTicketTypeItem?.sysField === Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.NOTICE
            ) {
                let isSelectedInternalThread = currentAiEventTypeSelected.find(
                    selectedTag =>
                        selectedTag?.sysField ===
                        Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER_CHAT_IN_PROJECT
                );
                isShow = !Utils.isEmptyObject(isSelectedInternalThread);
            }
            break;
        case Constant.AI_AUTO.CHAT_THREAD_TYPE_OPTION.THREAD_IN_PROJECT:
            {
                let isSelectedInternalThreadType = currentAiEventTypeSelected.find(
                    selectedTag =>
                        selectedTag?.sysField ===
                        Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER_CHAT_IN_PROJECT
                );
                isShow = !Utils.isEmptyObject(isSelectedInternalThreadType);
            }
            break;

        case Constant.AI_AUTO.CHAT_THREAD_TYPE_OPTION.THREAD_ESCALATION:
            if (
                [
                    Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.QA,
                    Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.EMAIL,
                    Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.TELEPHONE
                ].includes(selectedTicketTypeItem?.sysField)
            ) {
                isShow = true;
            }
            break;
        default:
            break;
    }

    return isShow;
};


export const validateShowCallCompletedAction = (aiAutoSelectedData) => {
    if (Utils.isEmptyObject(aiAutoSelectedData)) return false;
    const fieldTicketType = aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE];
    return !Utils.isEmptyArray(fieldTicketType) && fieldTicketType[0]?.sysField === Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.TELEPHONE;
}

/**
 * validateShowTagItemEventTrigger
 * @param {*} itemData 
 * @param {*} aiAutoSelectedData 
 */
export const validateShowTagItemEventTrigger = (itemData, aiAutoSelectedData = {}) => {
    if (Utils.isEmptyObject(itemData)) return false;

    if (itemData?.sysField === Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER_CALL_COMPLETED) {
        return validateShowCallCompletedAction(aiAutoSelectedData);
    }

    if (itemData?.sysField !== Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER_CHAT_OUTSIDE)
        return true;

    if (Utils.isEmptyObject(aiAutoSelectedData)) return false;

    let currentAiTicketTypeSelected =
        aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE];

    if (Utils.isEmptyArray(currentAiTicketTypeSelected)) return false;

    let selectedTicketTypeItem = currentAiTicketTypeSelected[0];

    return ![
        Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.TASK,
        Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.NOTICE
    ].includes(selectedTicketTypeItem?.sysField);
};

/**
 * validateShowTagItemReasoningEffort
 * @param {*} itemData - The reasoning effort option item data
 * @param {*} aiAutoSelectedData - The AI auto selected data containing chatgpt_model
 */
export const validateShowTagItemReasoningEffort = (itemData, aiAutoSelectedData = {}) => {
    if (Utils.isEmptyObject(itemData)) return false;

    // If not a reasoning effort option, show it (shouldn't happen, but safe fallback)
    const reasoningEffortTags = OpenAiUtil.getReasoningEffortTags();
    if (!reasoningEffortTags.includes(itemData?.sysField)) {
        return true;
    }
    
    const chatGptModelValue = aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.CHATGPT_MODEL];
    if (Utils.isEmptyArray(chatGptModelValue)) return true;

    const selectModel = chatGptModelValue[0];
    return OpenAiUtil.validateforGpt5(selectModel?.sysField, itemData?.sysField);
};


export const isShowButtonDuplicate = (
    corporationDetail,
    detailTicket,
    formDetail,
    selectedProject
) => {
    // const knowledgeService = [
    //     Constant.CORPORATION_CONTRACT_TYPE.GUEST,
    //     Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK
    // ].includes(corporationDetail.contractType)
    //     ? Utils.convertJSONDataToObject(corporationDetail?.inviterSetting)?.usingKnowledgeService
    //     : corporationDetail?.knowledgeService;
    // // Check on knowledge service
    // const isKnowledgeServiceOn = knowledgeService === Constant.STATUS_SERVICE_PERMISSION.ON;
    // Check type ticket
    const isTicketTypeAllowDuplicate =
        [Constant.TICKET_TYPE.KNOWLEDGE, Constant.TICKET_TYPE.MASTER_KNOWLEDGE].includes(
            detailTicket.ticketType
        ) && !detailTicket.deletedAt;

    // Project base, B2C does not allow duplicates
    const isProjectAllowDuplicate = ![
        Constant.PROJECT_TYPE.BASE,
        Constant.PROJECT_TYPE.CUSTOMER
    ].includes(selectedProject.type);

    // Corp support does not allow duplicates
    const isCorpAllowDuplicate = ![Constant.CORPORATION_CONTRACT_TYPE.GUEST].includes(
        corporationDetail.contractType
    );
    return (
        (formDetail?.isFormShareForProject ||
            detailTicket.public === Constant.TICKET_PUBLIC.DRAFT) &&
        // isKnowledgeServiceOn &&
        isTicketTypeAllowDuplicate &&
        isProjectAllowDuplicate &&
        isCorpAllowDuplicate
    );
};


/**
 * isShowFieldAIPDFPageSplitStatus
 * show and display ai_pdf_page_split_status 
 * @param {*} aiAutoSelectedData 
 * @returns 
 */
export const isShowFieldAIPDFPageSplitStatus = aiAutoSelectedData => {
    if (
        !aiAutoSelectedData ||
        Utils.isEmptyObject(aiAutoSelectedData) ||
        !aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER] ||
        Utils.isEmptyArray(aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER]) ||
        !aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE] ||
        Utils.isEmptyArray(aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE])
    ) {
        return false;
    }

    if (!Utils.isEmptyArray(aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE])) {
        if (
            ![
                Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.KNOWLEDGE
            ].includes(
                aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE][0]?.sysField
            )
        ) {
            return false;
        }
    }

    let currentAiEventTypeSelected =
        aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER];
    let isSelectedChatthreadValid = currentAiEventTypeSelected.find(selectedTag =>
        [
            Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER_CREATE,
            Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER_UPDATE
        ].includes(selectedTag?.sysField)
    );
    
    return !Utils.isEmptyObject(isSelectedChatthreadValid);
};

export const isShowReasoningEffortField = (aiAutoSelectedData = []) => {
    if (!aiAutoSelectedData) return false;
    const gptModelValue = aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.CHATGPT_MODEL];
    if (!isArray(gptModelValue)) return false;
    const isGptModelsNeedReasoning = gptModelValue?.find(selectedTag =>
        OpenAiUtil.isSupportReasoningBySystemTag(selectedTag?.sysField)
    );
    return !!isGptModelsNeedReasoning;
};


export const fetchAllMcpServers = async (corporationId, corporationContractType, projectId, userId, mcpIdList = []) => {
    let listMcpServerOptions = [];
    if (Utils.isEmptyString(corporationContractType)) {
        let corpData = await getCorporationById(null, corporationId);
        corporationContractType = corpData?.contractType;
    }

    try {
        if (
            !corporationId ||
            !projectId ||
            !userId ||
            corporationContractType !== Constant.CORPORATION_CONTRACT_TYPE.PREMIUM
        ) {
            return [];
        }

        let mcpServerList = [];
        let mcpServerListShow = [];

        // Separate saved IDs into cloud MCP vs local MCP
        const cloudMcpIdList = mcpIdList.filter(id => !id.includes(Constant.ID_PREFIX.MCP_CATALOG));
        // Local MCP saved on the ticket. Fetch their detail by catId so that an item OFF at org level
        // (which no longer appears in the project list) can still be shown as a saved chip.
        const localMcpIdList = mcpIdList.filter(id => id.includes(Constant.ID_PREFIX.MCP_CATALOG));
        const localMcpCatIdList = [...new Set(localMcpIdList.map(id => parseLocalMcpScope(id).catId))];

        const [mcpServerListInProject, mcpServerListOther, localMcpListForProject, savedLocalMcpDetailList] = await Promise.all([
            getMcpServerListByProject(projectId, userId, corporationId),
            getMcpServerByIdList(cloudMcpIdList),
            getLocalMcpListForProject(corporationId, projectId, userId).catch(() => []),
            getListMcpCatalogDetailByIds(localMcpCatIdList).catch(() => [])
        ]);

        mcpServerList = mcpServerListInProject.concat(mcpServerListOther);
        mcpServerListShow = mcpServerListInProject;

        if (!Utils.isEmptyArray(mcpServerList)) {
            // unique mcpServerList
            mcpServerList = mcpServerList.filter((item, index, self) =>
                index === self.findIndex((t) => t.id === item.id)
            );
        }

        let serverList = mcpServerList?.map(server => ({
            id: server.id,
            name: Utils.serverNameWithPrefix(server.serverName, server.type) || Constant.UNNAMED_MCP_SERVER,
            createdAt: server.createdAt,
            type: server.type,
            isShow: !Utils.isEmptyObject(mcpServerListShow.find(item => item.id === server.id))
        }));

        serverList = serverList?.sort((a, b) => {
            const dateA = new Date(a.createdAt);
            const dateB = new Date(b.createdAt);
            return dateB - dateA;
        });

        // Build local MCP options from project list
        let localMcpOptions = [];
        if (!Utils.isEmptyArray(localMcpListForProject)) {
            localMcpOptions = localMcpListForProject.map(item => {
                const { prefix } = parseLocalMcpScope(item.catId);
                const scopeLabel = prefix === LOCAL_MCP_PROJECT_PREFIX ? LOCAL_MCP_PROJECT_PREFIX : LOCAL_MCP_USER_PREFIX;
                return {
                    id: item.catId,
                    name: `${LOCAL_MCP_LABEL_PREFIX}${scopeLabel}${item.mcpName}`,
                    createdAt: item.createdAt || '',
                    type: Constant.MCP_SERVER_TYPE.MCP_CATALOG,
                    isShow: Boolean(item?.isActive)
                };
            });
        }

        // Filter: hide entire scope group if no connected item exists
        const hasConnectedUser = localMcpOptions.some(opt => {
            const { prefix } = parseLocalMcpScope(opt?.id);
            return prefix === LOCAL_MCP_USER_PREFIX && opt?.isShow;
        });
        const hasConnectedProject = localMcpOptions.some(opt => {
            const { prefix } = parseLocalMcpScope(opt?.id);
            return prefix === LOCAL_MCP_PROJECT_PREFIX && opt?.isShow;
        });
        localMcpOptions = localMcpOptions.filter(opt => {
            const isSavedOnTicket = mcpIdList.includes(opt?.id);
            const { prefix } = parseLocalMcpScope(opt?.id);
            if (prefix === LOCAL_MCP_USER_PREFIX && !hasConnectedUser && !isSavedOnTicket) return false;
            if (prefix === LOCAL_MCP_PROJECT_PREFIX && !hasConnectedProject && !isSavedOnTicket) return false;
            return true;
        });

        // Add back local MCP items saved on the ticket that are missing from the project list
        // (e.g. turned OFF at org level). They are added with isShow=false so the field keeps the
        // saved chip and shows the unavailable warning, while the dropdown still hides them.
        if (!Utils.isEmptyArray(localMcpIdList)) {
            const existingLocalMcpIds = new Set(localMcpOptions.map(opt => opt?.id));
            // A deleted local MCP no longer exists in DynamoDB, so its catId is absent from
            // savedLocalMcpDetailList. Drop such items entirely (no chip) before merging back;
            // only items that still exist (merely OFF) are kept as saved chips.
            const savedLocalMcpCatIds = new Set(
                savedLocalMcpDetailList.map(item => item?.id || item?.catId).filter(Boolean)
            );
            const availableSavedLocalMcpIdList = localMcpIdList.filter(scopedId => {
                const { catId } = parseLocalMcpScope(scopedId);
                return savedLocalMcpCatIds.has(catId);
            });
            availableSavedLocalMcpIdList.forEach(scopedId => {
                if (existingLocalMcpIds.has(scopedId)) return;
                const { catId, prefix } = parseLocalMcpScope(scopedId);
                const scopeLabel = prefix === LOCAL_MCP_PROJECT_PREFIX ? LOCAL_MCP_PROJECT_PREFIX : LOCAL_MCP_USER_PREFIX;
                const detail = savedLocalMcpDetailList.find(item => item?.id === catId || item?.catId === catId);
                const mcpName = detail?.mcpName || '';
                localMcpOptions.push({
                    id: scopedId,
                    name: `${LOCAL_MCP_LABEL_PREFIX}${scopeLabel}${mcpName}`,
                    createdAt: detail?.createdAt || '',
                    type: Constant.MCP_SERVER_TYPE.MCP_CATALOG,
                    isShow: false
                });
                existingLocalMcpIds.add(scopedId);
            });
        }

        listMcpServerOptions = [...serverList, ...localMcpOptions];

    } catch (error) {
        console.log('fetchMcpServers error:', error);
        listMcpServerOptions = [];
    }
    
    return listMcpServerOptions;
};

// Change isShowMCPServerSettingField to synchronous version
export const isShowMCPServerSettingField = (corporationDetail, detailTicket, isNewTicket) => {
    let isCorpPremium = corporationDetail.contractType === Constant.CORPORATION_CONTRACT_TYPE.PREMIUM;
    let limitValue = corporationDetail?.limitValue;
    let isRootOnMCPServer = limitValue?.mcpServer === Constant.STATUS_SERVICE_PERMISSION.ON;
    let corporationSetting = Utils.convertJSONDataToObject(corporationDetail?.corporationSetting);
    let usingMCPServer = corporationSetting?.usingMCPServer === Constant.STATUS_SERVICE_PERMISSION.ON;

    // Case 1: New ticket - return immediately
    if (isNewTicket) {
        return isCorpPremium && isRootOnMCPServer && usingMCPServer;
    }

    // Case 2: Different corporation - cannot check synchronously, return null to indicate needs async check
    if (corporationDetail?.id !== detailTicket?.affiliationOrganization) {
        // Return null to indicate this case needs special handling
        return null;
    }
    
    // Case 3: Same corporation - check current corp settings
    return isCorpPremium && isRootOnMCPServer && usingMCPServer;
};

// ========== AI TELEPHONE PROMPT HELPER FUNCTIONS ==========

/**
 * Check if AI_TELEPHONE_REALTIME_MODEL field should be displayed
 * Show when PROMPT_TYPE contains AUTO_RESPONSE
 * @param {Object} aiTelephoneSelectedData - State containing selected values
 * @returns {boolean}
 */
/**
 * Check if AI_TELEPHONE_REALTIME_MODEL field should be displayed
 * Show for Auto Response and Training forms
 * @param {Object} aiTelephoneSelectedData - State containing selected values
 * @returns {boolean}
 */
export const isShowRealtimeModelField = (aiTelephoneSelectedData = {}) => {
    if (Utils.isEmptyObject(aiTelephoneSelectedData)) return false;
    const formDetail = aiTelephoneSelectedData?.selectedFormDetail;
    return Utils.isSystemFormAITelephonePrompt(formDetail) || Utils.isSystemFormAITrainingPrompt(formDetail);
};

/**
 * Check if CHATGPT_MODEL field should be displayed in AI Telephone form
 * Show when PROMPT_TYPE has values other than AUTO_RESPONSE
 * @param {Object} aiTelephoneSelectedData
 * @returns {boolean}
 */
export const isShowChatGptModelFieldForTelephone = (aiTelephoneSelectedData = {}) => {
    if (Utils.isEmptyObject(aiTelephoneSelectedData)) return false;
    const formDetail = aiTelephoneSelectedData?.selectedFormDetail;
    // Show for Assistant only (Auto Response and Training don't use ChatGPT model)
    return Utils.isSystemFormAIAssistantPrompt(formDetail);
};

/**
 * Check if REASONING_EFFORT field should be displayed in AI Telephone form
 * Show when:
 * 1. PROMPT_TYPE has non-AUTO_RESPONSE values
 * 2. CHATGPT_MODEL is GPT_5 or GPT_5_1
 * @param {Object} aiTelephoneSelectedData
 * @returns {boolean}
 */
export const isShowReasoningEffortFieldForTelephone = (aiTelephoneSelectedData = {}) => {
    // Check condition 1: PROMPT_TYPE has non-AUTO_RESPONSE
    if (!isShowChatGptModelFieldForTelephone(aiTelephoneSelectedData)) return false;
    // Check condition 2: CHATGPT_MODEL is GPT_5 or GPT_5_1
    let chatGptModelValue = aiTelephoneSelectedData[Constant.SYSTEM_FIELD.CHATGPT_MODEL];
    chatGptModelValue = chatGptModelValue?.filter(value => !Utils.isEmptyObject(value))

    if (Utils.isEmptyArray(chatGptModelValue)) return false;
    
    // const hasReasoningModel = chatGptModelValue.some(
    //     item => [Constant.GPT_MODEL.GPT_5].includes(item?.title)
    // );

    const hasReasoningModel = chatGptModelValue.some(
        item => OpenAiUtil.isSupportReasoning(item?.title)
    ); 
    
    return hasReasoningModel;
};


/**
 * Check if AI_TELEPHONE_RECEIVING_CALL_EXECUTION_MODE field should be displayed
 * Show when TRIGGER_CONDITION contains RECEIVING
 * @param {Object} aiTelephoneSelectedData
 * @returns {boolean}
 */
export const isShowExecutionModeField = (aiTelephoneSelectedData = {}) => {
    if (Utils.isEmptyObject(aiTelephoneSelectedData)) return false;
    let isDisplayTriggerCondition = isShowTriggerConditionField(aiTelephoneSelectedData);

    if(!isDisplayTriggerCondition) return false;

    let triggerConditionValue = aiTelephoneSelectedData[Constant.SYSTEM_FIELD.AI_TELEPHONE_TRIGGER_CONDITION];
    triggerConditionValue = triggerConditionValue?.filter(value => !Utils.isEmptyObject(value))
    if (Utils.isEmptyArray(triggerConditionValue)) return false;
    
    const hasReceiving = triggerConditionValue.some(
        item => item?.sysField === Constant.SYSTEM_FIELD.AI_TELEPHONE_TRIGGER_CONDITION_RECEIVING
    );
    
    return hasReceiving;
};

/**
 * Check if AI_TELEPHONE_EXECUTION_SCOPE field should be displayed
 * Show when PROMPT_TYPE has values other than TRAINING
 * @param {Object} aiTelephoneSelectedData
 * @returns {boolean}
 */
export const isShowExecutionScopeField = (aiTelephoneSelectedData = {}) => {
    if (Utils.isEmptyObject(aiTelephoneSelectedData)) return false;
    const formDetail = aiTelephoneSelectedData?.selectedFormDetail;
    // Show for Auto Response and Assistant (not Training)
    return Utils.isSystemFormAITelephonePrompt(formDetail) || Utils.isSystemFormAIAssistantPrompt(formDetail);
};

/**
 * Check if AI_TELEPHONE_APPLICABLE_PHONE_NUMBER field should be displayed
 * Show when EXECUTION_SCOPE contains EXTERNAL
 * @param {Object} aiTelephoneSelectedData
 * @returns {boolean}
 */
export const isShowApplicablePhoneNumberField = (aiTelephoneSelectedData = {}) => {
    if (Utils.isEmptyObject(aiTelephoneSelectedData)) return false;
    
    let executionScopeValue = aiTelephoneSelectedData[Constant.SYSTEM_FIELD.AI_TELEPHONE_EXECUTION_SCOPE];
    executionScopeValue = executionScopeValue?.filter(value => !Utils.isEmptyObject(value))
    if (Utils.isEmptyArray(executionScopeValue)) return false;
    
    const hasExternal = executionScopeValue.some(
        item => item?.sysField === Constant.SYSTEM_FIELD.AI_TELEPHONE_EXECUTION_SCOPE_EXTERNAL
    );
    
    return hasExternal;
};

/**
 * Check if AI_TELEPHONE_VOICE_SETTINGS field should be displayed
 * Show when PROMPT_TYPE contains TRAINING or AUTO_RESPONSE
 * @param {Object} aiTelephoneSelectedData
 * @returns {boolean}
 */
export const isShowVoiceSettingsField = (aiTelephoneSelectedData = {}) => {
    if (Utils.isEmptyObject(aiTelephoneSelectedData)) return false;
    const formDetail = aiTelephoneSelectedData?.selectedFormDetail;
    // Show for Auto Response and Training
    return Utils.isSystemFormAITelephonePrompt(formDetail) || Utils.isSystemFormAITrainingPrompt(formDetail);
};

/**
 * Check if AI_TELEPHONE_VOICE_SETTINGS field should be displayed
 * Show when PROMPT_TYPE contains TRAINING or AUTO_RESPONSE
 * @param {Object} aiTelephoneSelectedData
 * @returns {boolean}
 */
export const isShowTriggerConditionField = (aiTelephoneSelectedData = {}) => {
    if (Utils.isEmptyObject(aiTelephoneSelectedData)) return false;
    const formDetail = aiTelephoneSelectedData?.selectedFormDetail;
    // Show for Auto Response and Assistant (not Training)
    return Utils.isSystemFormAITelephonePrompt(formDetail) || Utils.isSystemFormAIAssistantPrompt(formDetail);
};

/**
 * Check if time execution fields should be displayed
 * (START_TIME, END_TIME, START_DATE, END_DATE, DAY_OF_WEEKS)
 * Show when RECEIVING_CALL_EXECUTION_TIME_PERIOD has value
 * @param {Object} aiTelephoneSelectedData
 * @returns {boolean}
 */
export const isShowTimeExecutionFields = (aiTelephoneSelectedData = {}) => {
    if (Utils.isEmptyObject(aiTelephoneSelectedData)) return false;
    
    let timePeriodValue = aiTelephoneSelectedData[
        Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_TIME_PERIOD
    ];
    timePeriodValue = timePeriodValue?.filter(value => !Utils.isEmptyObject(value))
    if (Utils.isEmptyArray(timePeriodValue)) return false;
    
    return !Utils.isEmptyArray(timePeriodValue);
};

export const isShowTimeExecutionPeriod = (aiTelephoneSelectedData) => {
    if (Utils.isEmptyObject(aiTelephoneSelectedData)) return false;
    const formDetail = aiTelephoneSelectedData?.selectedFormDetail;
    // Show for Auto Response only
    return Utils.isSystemFormAITelephonePrompt(formDetail);
}

/**
 * Validate if a trigger condition tag item should be shown based on prompt type selection
 * - ai_telephone_trigger_condition_receiving: show when prompt_type = auto_response OR assistant OR call_evaluation
 * - ai_telephone_trigger_condition_training: show when prompt_type = assistant OR call_evaluation
 * @param {Object} itemData - The tag item data to validate
 * @param {Object} aiTelephoneSelectedData - State containing selected values
 * @returns {boolean} - true if item should be shown
 */
export const validateShowTagItemTriggerCondition = (itemData, aiTelephoneSelectedData = {}) => {
    if (Utils.isEmptyObject(itemData)) return false;

    const itemSysField = itemData?.sysField;
    const formDetail = aiTelephoneSelectedData?.selectedFormDetail;

    // ============================================================
    // TEMPORARY: Hide 'making' option - out of scope for Phase 1
    // TODO: Remove this block when implementing Phase 2
    // ============================================================
    if (itemSysField === Constant.SYSTEM_FIELD.AI_TELEPHONE_TRIGGER_CONDITION_MAKING) {
        return false;
    }
    // ============================================================

    // Visibility rules based on definitionVariant
    switch (itemSysField) {
        case Constant.SYSTEM_FIELD.AI_TELEPHONE_TRIGGER_CONDITION_RECEIVING:
            // Show for Auto Response and Assistant
            return Utils.isSystemFormAITelephonePrompt(formDetail) || Utils.isSystemFormAIAssistantPrompt(formDetail);

        case Constant.SYSTEM_FIELD.AI_TELEPHONE_TRIGGER_CONDITION_TRAINING:
            // Show for Training and Assistant
            return Utils.isSystemFormAITrainingPrompt(formDetail) || Utils.isSystemFormAIAssistantPrompt(formDetail);

        case Constant.SYSTEM_FIELD.AI_TELEPHONE_TRIGGER_CONDITION_APP_INTEGRATION:
            // Show only for Assistant
            return Utils.isSystemFormAIAssistantPrompt(formDetail);

        default:
            return true;
    }
};

/**
 * Check if time_based_delay_response field should be shown
 * Conditions:
 * 1. execution_mode field must be visible (trigger_condition = RECEIVING)
 * 2. execution_mode = answering_machine
 */
export const isShowTimeBasedDelayResponseField = (aiTelephoneSelectedData = {}) => {
    // First check if execution_mode field is visible
    if (!isShowExecutionModeField(aiTelephoneSelectedData)) return false;
    
    const executionModeValue = aiTelephoneSelectedData[
        Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_MODE
    ];
    
    if (Utils.isEmptyArray(executionModeValue)) return false;
    
    return executionModeValue.some(item => 
        item?.sysField === Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_MODE_ANSWERING_MACHINE
    );
};

/**
 * Validate if execution scope tag item should be shown based on project isPublic
 * - ai_telephone_execution_scope_internal: always show
 * - ai_telephone_execution_scope_external: only show when owner project isPublic = true
 * @param {Object} itemData - The tag item data to validate
 * @param {Object} affiliationProjectOfTicket - Project that owns the Knowledge
 * @returns {boolean} - true if item should be shown
 */
export const validateShowTagItemExecutionScope = (itemData, affiliationProjectOfTicket = {}) => {
    if (Utils.isEmptyObject(itemData)) return false;

    const itemSysField = itemData?.sysField;

    // 内線 (internal) always visible
    if (itemSysField === Constant.SYSTEM_FIELD.AI_TELEPHONE_EXECUTION_SCOPE_INTERNAL) {
        return true;
    }

    // 外線 (external) only visible when owner project has isPublic = true
    if (itemSysField === Constant.SYSTEM_FIELD.AI_TELEPHONE_EXECUTION_SCOPE_EXTERNAL) {
        return affiliationProjectOfTicket?.isPublic === true;
    }

    return true;
};

export const triggerValueWhenFieldHasSubscriptionUpdate = async (subscriptionFieldValue, sysField, userDetail, corporationDetail) => {
    if (!subscriptionFieldValue) return null;

    // Handle CALL_HANDLER field
    if (sysField === TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALL_HANDLER) {
        const subscriptionValue = Array.isArray(subscriptionFieldValue)
            ? subscriptionFieldValue[0]
            : subscriptionFieldValue;

        if (!subscriptionValue) {
            return [];
        }

        const newTagValue = await buildCallHandlerTagValue(subscriptionValue, sysField, userDetail);
        return !Utils.isEmptyArray(newTagValue) ? newTagValue : [];
    }

    // Handle AI_OPERATOR_PROMPT field
    if (sysField === TelephoneConstant.TELEPHONE.SYSTEM_FIELD.AI_OPERATOR_PROMPT) {
        const valueList = Array.isArray(subscriptionFieldValue) ? subscriptionFieldValue : [subscriptionFieldValue];

        if (Utils.isEmptyArray(valueList) || !valueList[0]) {
            return [];
        }

        return await buildAiOperatorPromptTagValue(valueList, sysField, corporationDetail);
    }

    return null;
};

/**
 * Fetch AI operator prompt ticket info and build tag value objects for MenuTagInPutBase
 */
export const buildAiOperatorPromptTagValue = async (defaultValue, sysField, corporationDetail) => {
    if (Utils.isEmptyArray(defaultValue)) return [];

    const apiPromises = defaultValue.map(value => {
        const ticketId = typeof value === 'string' ? value : value?.value;
        if (!ticketId) return null;
        return getPublicAPI(null, {
            getApiType: Constant.GET_API_PUBLIC_TYPE.GET_TICKET_OPERATOR_ELS_DATA,
            corporationId: corporationDetail?.id,
            ticketId: ticketId,
        }).catch(() => null);
    }).filter(Boolean);

    try {
        const results = await Promise.all(apiPromises);
        const operatorPromptOptions = [];
        results.forEach(data => {
            if (data?.success) {
                let ticketData = Utils.convertJSONDataToObject(data.payload);
                const { id, name, shareLink } = ticketData;
                operatorPromptOptions.push({
                    id: id,
                    value: id,
                    title: name,
                    sysField: sysField,
                    isShow: true,
                    isShowItemInTicket: true,
                    shareLink: shareLink
                });
            }
        });
        return operatorPromptOptions;
    } catch (error) {
        console.error('buildAiOperatorPromptTagValue Error >>>', error);
        return [];
    }
}

/**
 * Fetch call handler user info and build tag value object for MenuTagInPutBase
 */
export const buildCallHandlerTagValue = async (defaultValue, sysField, currentUserDetail) => {
    if (!defaultValue) return [];
    try {
        let callHandlerData = {};

        if (defaultValue === currentUserDetail?.id) {
            const tagValue = [{
                id: currentUserDetail?.id,
                value: currentUserDetail?.id,
                title: getCallHandlerDisplayName(
                    currentUserDetail?.id,
                    Utils.getFullNameOfUserWithActiveStatus(Constant.LANGUAGE_TYPE.JP, currentUserDetail)
                ),
                sysField: sysField,
                isShow: true,
                isShowItemInTicket: true
            }];
            return tagValue;
        } else {
            const result = await getPublicAPI(null, {
                getApiType: Constant.GET_API_PUBLIC_TYPE.GET_CALL_HANDLER_DEFAULT_VALUE,
                corporationId: localStorageUtil.getAffiliationOrganization(),
                defaultValue: defaultValue
            });
            
            if (!result.success) return [];
            callHandlerData = Utils.convertJSONDataToObject(result.payload);
            if (callHandlerData?.id && callHandlerData?.name) {
                const tagValue = [{
                    id: callHandlerData.id,
                    value: callHandlerData.id,
                    title: getCallHandlerDisplayName(callHandlerData.id, callHandlerData.name),
                    sysField: sysField,
                    isShow: true,
                    isShowItemInTicket: true
                }];
                return tagValue;
            }
        }
    } catch (err) {
        console.error('buildCallHandlerTagValue Error >>>', err);
    }
    
    return [];
};


export const isShowAiPromptApplicationTarget = ({
    allFormData = {},
    fieldListData = [],
    formDetail = {}
}) => {
    if (!Utils.isSystemFormKBoardPrompt(formDetail)) return true;

    const applyAiPromptField = fieldListData?.find(
        field => field?.sysField === Constant.SYSTEM_FIELD.APPLY_AI_PROMPT
    );
    if (!applyAiPromptField) return false;

    const fieldValue = allFormData[applyAiPromptField?.id];
    if (!Array.isArray(fieldValue)) return false;

    return fieldValue.some(i => i?.sysField === Constant.APPLY_AI_PROMPT.ON);
};
